<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <div class="bg-white shadow-sm border-b border-gray-200">
    <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 py-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center space-x-4">
          <button 
            (click)="goBack()" 
            class="flex items-center text-gray-600 hover:text-gray-800 transition-colors">
            <i class="fas fa-arrow-left mr-2"></i>
            <span class="font-medium">Volver</span>
          </button>
          <div class="h-6 w-px bg-gray-300"></div>
          <div class="flex items-center space-x-3">
            <i class="fas fa-cog text-blue-600 text-2xl"></i>
            <div>
              <h1 class="text-2xl font-bold text-gray-800">Configuración de Domiciliación</h1>
              <p class="text-sm text-gray-500">Gestiona la configuración de todos los productos</p>
            </div>
          </div>
        </div>
        
        <div class="flex items-center space-x-3">
          <span class="text-sm text-gray-600">
            {{filteredProducts.length}} producto(s)
          </span>
          <button
            [routerLink]="['/console/registro-cobros-archivo']"
            class="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors"
            title="Registrar cobros desde un archivo de respuesta (remediación)">
            <i class="fas fa-file-import mr-2"></i>Registrar cobros (archivo)
          </button>
          <button
            (click)="goToProductsManagement()"
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
            <i class="fas fa-edit mr-2"></i>Gestión de Productos
          </button>
          <button 
            (click)="exportToCSV()" 
            class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors">
            <i class="fas fa-download mr-2"></i>Exportar CSV
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tab Navigation -->
  <div class="bg-white border-b border-gray-200">
    <div class="px-4 mx-auto max-w-screen-2xl lg:px-12">
      <nav class="flex space-x-8" aria-label="Tabs">
        <button
          (click)="switchTab('active-debits')"
          [class]="activeTab === 'active-debits' 
            ? 'border-blue-600 text-blue-600' 
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-list-alt mr-2"></i>
          Domiciliaciones Activas
        </button>
        <button
          (click)="switchTab('historical-debits')"
          [class]="activeTab === 'historical-debits' 
            ? 'border-blue-600 text-blue-600' 
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-history mr-2"></i>
          Histórico de Domiciliaciones
        </button>
        <button
          (click)="switchTab('product-config')"
          [class]="activeTab === 'product-config' 
            ? 'border-blue-600 text-blue-600' 
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-cog mr-2"></i>
          Configuración por Productos
        </button>
        <button
          (click)="switchTab('deactivation-log')"
          [class]="activeTab === 'deactivation-log' 
            ? 'border-red-600 text-red-600' 
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-ban mr-2"></i>
          Bajas por Morosidad
        </button>
        <!-- Oculto temporalmente (en revisión): Lector de cobros
        <button
          (click)="switchTab('cobros-reader')"
          [class]="activeTab === 'cobros-reader'
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-file-invoice-dollar mr-2"></i>
          Lector de cobros
        </button>
        -->
        <button
          (click)="switchTab('alerts-config')"
          [class]="activeTab === 'alerts-config'
            ? 'border-blue-600 text-blue-600'
            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-bell mr-2"></i>
          Alertas
        </button>
      </nav>
    </div>
  </div>

  <!-- Main Content -->
  <div class="px-4 mx-auto max-w-screen-2xl lg:px-12 py-8">
    
    <!-- Active Direct Debits Tab -->
    <div *ngIf="activeTab === 'active-debits'">
      <!-- Export Button -->
      <div class="flex justify-end mb-4">
        <button 
          (click)="exportActiveDebitsToCSV()"
          class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors shadow-md">
          <i class="fas fa-file-excel mr-2"></i>Exportar CSV
        </button>
      </div>

      <!-- Filters -->
      <div class="bg-white shadow-md rounded-lg mb-6 p-6">
        <div class="grid md:grid-cols-3 gap-4">
          <!-- Bank Filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              <i class="fas fa-university mr-2"></i>Filtrar por Banco
            </label>
            <select 
              [(ngModel)]="filterBank"
              (ngModelChange)="applyActiveDebitsFilters()"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Todos los bancos</option>
              <option *ngFor="let bank of banksList" [value]="bank.code">{{bank.name}}</option>
            </select>
          </div>

          <!-- Type Filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              <i class="fas fa-filter mr-2"></i>Filtrar por Tipo
            </label>
            <select 
              [(ngModel)]="filterType"
              (ngModelChange)="applyActiveDebitsFilters()"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Todos los tipos</option>
              <option value="1">Cuotas - Diario</option>
              <option value="2">Cuotas - Masivo</option>
              <option value="3">Cuotas - Morosos</option>
              <option value="4">Penalidades</option>
            </select>
          </div>

          <!-- Summary & Actions -->
          <div class="flex flex-col gap-2">
            <div class="px-4 py-2 bg-blue-50 rounded-lg">
              <div class="text-sm text-gray-600">Total de lotes</div>
              <div class="text-2xl font-bold text-blue-600">
                {{filteredActiveDebits.length}}
                <span *ngIf="filterBank || filterType" class="text-sm text-gray-500">
                  / {{activeDirectDebits.length}}
                </span>
              </div>
            </div>
            <button 
              *ngIf="filterBank || filterType"
              (click)="clearActiveDebitsFilters()"
              class="px-3 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-sm">
              <i class="fas fa-times mr-1"></i>Limpiar filtros
            </button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoading" class="bg-white shadow-md rounded-lg p-12 text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p class="text-gray-600">Cargando domiciliaciones activas...</p>
      </div>

      <!-- Active Debits Content -->
      <div *ngIf="!isLoading">
        <div *ngIf="groupedByProduct.size === 0" class="bg-white shadow-md rounded-lg p-12 text-center">
          <i class="fas fa-inbox text-gray-400 text-4xl mb-3"></i>
          <p class="text-gray-600">No hay domiciliaciones activas en este momento</p>
        </div>

        <!-- Grouped by Product -->
        <div *ngFor="let entry of groupedByProduct | keyvalue" class="mb-6">
          <div class="bg-white shadow-md rounded-lg overflow-hidden">
            <!-- Product Header -->
            <div class="bg-gradient-to-r from-gray-100 to-gray-200 px-6 py-4 border-b border-gray-300">
              <div class="flex items-center justify-between gap-3 flex-wrap">
                <h3 class="text-lg font-semibold text-gray-800 flex items-center mb-0">
                  <i class="fas fa-box mr-3"></i>
                  {{getProductName(entry.key)}}
                  <span class="ml-3 px-3 py-1 bg-blue-600 text-white rounded-full text-sm font-medium">
                    {{entry.value.length}} lote(s)
                  </span>
                </h3>
                <!-- Refresco manual: la tabla no se actualiza sola, así que se dice de
                     cuándo es la foto. Un dato viejo sin fecha es peor que no tenerlo. -->
                <div class="flex items-center gap-2 text-xs text-gray-600">
                  <span *ngIf="activeLoadedAt">Actualizado {{ desdeHace(activeLoadedAt) }}</span>
                  <button (click)="loadActiveDirectDebits()"
                          [disabled]="isLoading"
                          title="Actualizar la lista de lotes"
                          class="px-2.5 py-1 rounded-md border border-gray-300 bg-white hover:bg-gray-50 transition-colors disabled:opacity-50">
                    <i class="fas fa-sync-alt mr-1" [ngClass]="{'fa-spin': isLoading}"></i>Actualizar
                  </button>
                </div>
              </div>
            </div>

            <!-- Debits Table -->
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead class="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Lote</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Tipo</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Banco</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Fecha</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Estado</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Procesado</th>
                    <th class="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase">Total</th>
                    <th class="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase">Acciones</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr *ngFor="let dd of entry.value" class="hover:bg-gray-50 transition-colors">
                    <td class="px-4 py-3">
                      <div class="font-medium text-gray-900">
                        {{dd.lote || dd.manual_lote || '-'}}
                        <span *ngIf="dd?.params?.special_flow"
                              class="ms-1 inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold"
                              style="background-color:#dbeafe;color:#1e40af;"
                              title="Lote generado por el Flujo Especial (ex-domiciliados)">
                          Especial
                        </span>
                      </div>
                      <!-- Número de lote del banco (solo bancos de lote manual).
                           Lo teclea una persona y se carga mal a menudo; hasta ahora no
                           había forma de corregirlo mientras el proceso seguía vivo. -->
                      <div *ngIf="usaLoteManual(dd)" class="mt-1 flex items-center gap-1.5">
                        <span class="text-xs text-gray-500">Nro. banco:</span>
                        <span class="text-xs font-mono"
                              [class]="dd.manual_lote ? 'text-gray-800' : 'text-amber-600 italic'">
                          {{ dd.manual_lote || 'sin asignar' }}
                        </span>
                        <button *ngIf="puedeEditarLoteManual(dd)"
                                (click)="editarLoteManual(dd)"
                                type="button"
                                class="text-blue-600 hover:text-blue-800 text-xs"
                                [title]="dd.manual_lote ? 'Corregir el número de lote del banco' : 'Asignar el número de lote del banco'">
                          <i class="fas fa-edit"></i>
                        </button>
                        <i *ngIf="!puedeEditarLoteManual(dd)"
                           class="fas fa-lock text-gray-300 text-xs"
                           title="El proceso ya finalizó: el número no se puede cambiar"></i>
                      </div>
                    </td>
                    <td class="px-4 py-3">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
                        {{dd.type_name || 'N/A'}}
                      </span>
                    </td>
                    <td class="px-4 py-3">
                      <span class="text-gray-900">{{dd.bank?.name || '-'}}</span>
                      <div class="text-xs text-gray-500">{{dd.bank?.code || '-'}}</div>
                    </td>
                    <!-- Hora real de arranque, no la fecha de negocio del lote: esa se
                         guarda a medianoche y la columna mostraba siempre "00:00". -->
                    <td class="px-4 py-3 text-gray-600">
                      <div [title]="fechaInicioTooltip(dd)">{{formatDate(fechaInicioProceso(dd))}}</div>
                    </td>
                    <td class="px-4 py-3">
                      <span 
                        [class]="dd.completed ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'"
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium">
                        {{dd.completed ? 'COMPLETADO' : dd.status || 'ACTIVO'}}
                      </span>
                    </td>
                    <!-- Completitud: qué proporción de los registros del lote llegó a un
                         desenlace. Sólo se exige el 100% en lotes ya conciliados; antes de
                         eso estar al 0% es lo normal y marcarlo sería ruido. -->
                    <td class="px-4 py-3">
                      <div *ngIf="tieneCompletitud(dd); else sinDatos" [title]="completitudTooltip(dd)" class="min-w-[110px]">
                        <div class="flex items-center gap-1.5">
                          <div class="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                            <div class="h-full rounded-full transition-all"
                                 [ngClass]="tieneAlerta(dd) ? 'bg-amber-500' : (esConciliado(dd) ? 'bg-gray-400' : 'bg-gray-300')"
                                 [style.width.%]="porcentajeProcesado(dd)"></div>
                          </div>
                          <i *ngIf="tieneAlerta(dd)" class="fas fa-exclamation-triangle text-amber-500 text-[11px]"></i>
                        </div>
                        <div class="text-[11px] mt-0.5"
                             [ngClass]="tieneAlerta(dd) ? 'text-amber-700 font-semibold' : 'text-gray-500'">
                          {{ porcentajeTexto(dd) }}
                          <span *ngIf="tieneAlerta(dd)">· faltan {{ dd.processed_stats.pending }}</span>
                        </div>
                      </div>
                      <ng-template #sinDatos><span class="text-gray-400 text-xs">—</span></ng-template>
                    </td>
                    <td class="px-4 py-3 text-right font-medium text-gray-900">
                      {{dd.total_amount | number:'1.2-2'}}
                    </td>
                    <td class="px-4 py-3">
                      <div class="flex gap-2 justify-center">
                        <button 
                          (click)="openTimelineModal(dd)"
                          class="px-3 py-1.5 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors text-xs">
                          <i class="fas fa-tasks mr-1"></i>Progreso
                        </button>
                        <button
                          (click)="openPaymentsModal(dd)"
                          class="px-3 py-1.5 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors text-xs">
                          <i class="fas fa-money-bill-wave mr-1"></i>Cobros
                        </button>
                        <button
                          (click)="descargarCobrosExcel(dd)"
                          [disabled]="downloadingExcel[dd.lote || dd.manual_lote]"
                          title="Descargar Excel de cobros y clientes del lote"
                          class="px-3 py-1.5 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors text-xs disabled:opacity-50">
                          <i class="fas mr-1" [ngClass]="downloadingExcel[dd.lote || dd.manual_lote] ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>Excel
                        </button>
                        <!-- NUEVO: Botón de Estatus de Reporte (solo para seguros) -->
                        <button 
                          *ngIf="isInsuranceDomiciliation(dd)"
                          (click)="openInsuranceReportModal(dd)"
                          class="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-xs">
                          <i class="fas fa-file-medical-alt mr-1"></i>Estatus de Reporte
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Historical Direct Debits Tab -->
    <div *ngIf="activeTab === 'historical-debits'">
      <!-- Export Button -->
      <div class="flex justify-end mb-4">
        <button 
          (click)="exportHistoricalDebitsToCSV()"
          class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors shadow-md">
          <i class="fas fa-file-excel mr-2"></i>Exportar CSV
        </button>
      </div>

      <!-- Filters -->
      <div class="bg-white shadow-md rounded-lg mb-6 p-6">
        <div class="grid md:grid-cols-4 gap-4">
          <!-- Búsqueda por lote: va primero porque es la forma más directa de llegar a un
               lote puntual. Sin esto había que acertarle a la fecha, que es justo el dato
               que no se tiene cuando se lo está buscando. -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              <i class="fas fa-search mr-2"></i>Lote
            </label>
            <div class="dd-input-wrap">
              <input
                type="text"
                [(ngModel)]="historicalFilterLote"
                (keyup.enter)="buscarPorLote()"
                placeholder="Ej: 3731 ó 00003731"
                class="w-full px-3 py-2 pr-8 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
              <button *ngIf="historicalFilterLote"
                      (click)="historicalFilterLote = ''; applyHistoricalFilters()"
                      title="Limpiar la búsqueda por lote"
                      class="dd-clear-input">
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div *ngIf="historicalFilterLote" class="text-[11px] text-gray-500 mt-1">
              <i class="fas fa-info-circle mr-1"></i>Se busca en todo el histórico, sin filtrar por fecha
            </div>
          </div>

          <!-- Date Filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              <i class="fas fa-calendar mr-2"></i>Fecha
            </label>
            <input
              type="date"
              [(ngModel)]="historicalDate"
              [disabled]="!!historicalFilterLote"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:text-gray-400">
          </div>

          <!-- Bank Filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              <i class="fas fa-university mr-2"></i>Banco
            </label>
            <select 
              [(ngModel)]="historicalFilterBank"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Todos los bancos</option>
              <option *ngFor="let bank of banksList" [value]="bank.code">{{bank.name}}</option>
            </select>
          </div>

          <!-- Type Filter -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              <i class="fas fa-filter mr-2"></i>Tipo
            </label>
            <select 
              [(ngModel)]="historicalFilterType"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
              <option value="">Todos los tipos</option>
              <option value="1">Cuotas - Diario</option>
              <option value="2">Cuotas - Masivo</option>
              <option value="3">Cuotas - Morosos</option>
              <option value="4">Penalidades</option>
            </select>
          </div>
        </div>

        <!-- Summary & Actions -->
        <div class="flex items-center justify-between mt-4">
          <div class="px-4 py-2 bg-blue-50 rounded-lg">
            <div class="text-sm text-gray-600">Total de lotes históricos</div>
            <div class="text-2xl font-bold text-blue-600">
              {{ historicalTotal }}
              <span *ngIf="historicalTotal > 0" class="text-sm text-gray-500 font-normal">
                · viendo {{ rangoHistorico.desde }}–{{ rangoHistorico.hasta }}
              </span>
            </div>
          </div>
          <div class="flex gap-2">
            <button
              (click)="buscarPorLote()"
              class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm">
              <i class="fas fa-search mr-1"></i>Buscar
            </button>
            <button
              *ngIf="historicalFilterBank || historicalFilterType || historicalDate || historicalFilterLote"
              (click)="clearHistoricalFilters()"
              class="px-3 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors text-sm">
              <i class="fas fa-times mr-1"></i>Limpiar filtros
            </button>
            <!-- Refresco manual del histórico, con la marca de cuándo se cargó. -->
            <button
              (click)="loadHistoricalDirectDebits()"
              [disabled]="isLoadingHistorical"
              title="Actualizar el histórico"
              class="px-3 py-2 border border-gray-300 bg-white text-gray-700 rounded-md hover:bg-gray-50 transition-colors text-sm disabled:opacity-50">
              <i class="fas fa-sync-alt mr-1" [ngClass]="{'fa-spin': isLoadingHistorical}"></i>Actualizar
            </button>
            <span *ngIf="historicalLoadedAt" class="self-center text-xs text-gray-500">
              {{ desdeHace(historicalLoadedAt) }}
            </span>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoadingHistorical" class="bg-white shadow-md rounded-lg p-12 text-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p class="text-gray-600">Cargando histórico...</p>
      </div>

      <!-- Historical Debits Content -->
      <div *ngIf="!isLoadingHistorical && filteredHistoricalDebits.length > 0">
        <div *ngFor="let entry of groupedHistoricalDebits | keyvalue" class="mb-6">
          <div class="bg-gradient-to-r from-gray-100 to-gray-50 rounded-t-lg px-6 py-3 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <h3 class="text-lg font-semibold text-gray-800">{{getProductName(entry.key)}}</h3>
              <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                {{entry.value.length}} lotes
              </span>
            </div>
          </div>
          <div class="bg-white shadow-md rounded-b-lg overflow-hidden">
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead class="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Lote</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Tipo</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Banco</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Fecha</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Estado</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Procesado</th>
                    <th class="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase">Total</th>
                    <th class="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase">Acciones</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr *ngFor="let dd of entry.value" class="hover:bg-gray-50 transition-colors">
                    <td class="px-4 py-3">
                      <div class="font-medium text-gray-900">
                        {{dd.lote || dd.manual_lote || '-'}}
                        <span *ngIf="dd?.params?.special_flow"
                              class="ms-1 inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold"
                              style="background-color:#dbeafe;color:#1e40af;"
                              title="Lote generado por el Flujo Especial (ex-domiciliados)">
                          Especial
                        </span>
                      </div>
                    </td>
                    <td class="px-4 py-3">
                      <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800">
                        {{dd.type_name || 'N/A'}}
                      </span>
                    </td>
                    <td class="px-4 py-3">
                      <span class="text-gray-900">{{dd.bank?.name || '-'}}</span>
                    </td>
                    <td class="px-4 py-3 text-gray-600 text-xs">
                      <div [title]="fechaInicioTooltip(dd)">{{formatDate(fechaInicioProceso(dd))}}</div>
                    </td>
                    <td class="px-4 py-3">
                      <span
                        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                        {{dd.status || 'COMPLETADO'}}
                      </span>
                    </td>
                    <!-- Completitud — misma lectura que en la tabla de activos. En el
                         histórico es donde más sirve: son lotes viejos que nadie vuelve a
                         mirar salvo que algo los delate. -->
                    <td class="px-4 py-3">
                      <div *ngIf="tieneCompletitud(dd); else sinDatosHist" [title]="completitudTooltip(dd)" class="min-w-[110px]">
                        <div class="flex items-center gap-1.5">
                          <div class="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden">
                            <div class="h-full rounded-full transition-all"
                                 [ngClass]="tieneAlerta(dd) ? 'bg-amber-500' : (esConciliado(dd) ? 'bg-gray-400' : 'bg-gray-300')"
                                 [style.width.%]="porcentajeProcesado(dd)"></div>
                          </div>
                          <i *ngIf="tieneAlerta(dd)" class="fas fa-exclamation-triangle text-amber-500 text-[11px]"></i>
                        </div>
                        <div class="text-[11px] mt-0.5"
                             [ngClass]="tieneAlerta(dd) ? 'text-amber-700 font-semibold' : 'text-gray-500'">
                          {{ porcentajeTexto(dd) }}
                          <span *ngIf="tieneAlerta(dd)">· faltan {{ dd.processed_stats.pending }}</span>
                        </div>
                      </div>
                      <ng-template #sinDatosHist><span class="text-gray-400 text-xs">—</span></ng-template>
                    </td>
                    <td class="px-4 py-3 text-right font-medium text-gray-900">
                      {{dd.total_amount | number:'1.2-2'}}
                    </td>
                    <td class="px-4 py-3">
                      <div class="flex gap-2 justify-center">
                        <button 
                          (click)="openTimelineModal(dd)"
                          class="px-3 py-1.5 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors text-xs">
                          <i class="fas fa-tasks mr-1"></i>Progreso
                        </button>
                        <button
                          (click)="openPaymentsModal(dd)"
                          class="px-3 py-1.5 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors text-xs">
                          <i class="fas fa-money-bill-wave mr-1"></i>Cobros
                        </button>
                        <button
                          (click)="descargarCobrosExcel(dd)"
                          [disabled]="downloadingExcel[dd.lote || dd.manual_lote]"
                          title="Descargar Excel de cobros y clientes del lote"
                          class="px-3 py-1.5 bg-teal-600 text-white rounded-md hover:bg-teal-700 transition-colors text-xs disabled:opacity-50">
                          <i class="fas mr-1" [ngClass]="downloadingExcel[dd.lote || dd.manual_lote] ? 'fa-spinner fa-spin' : 'fa-file-excel'"></i>Excel
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Paginado. El histórico trae 20 por página: sin esto, limpiar el filtro de fecha
           pedía los 4.467 lotes de una vez y la pantalla quedaba colgada. -->
      <div *ngIf="!isLoadingHistorical && historicalPages > 1"
           class="bg-white shadow-md rounded-lg px-4 py-3 mt-4 flex items-center justify-between gap-3 flex-wrap">
        <div class="text-sm text-gray-600">
          Mostrando <strong>{{ rangoHistorico.desde }}–{{ rangoHistorico.hasta }}</strong>
          de <strong>{{ historicalTotal }}</strong> lotes
        </div>
        <div class="flex items-center gap-1">
          <button (click)="irAPaginaHistorico(1)" [disabled]="historicalPage === 1"
                  title="Primera página"
                  class="px-2.5 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button (click)="irAPaginaHistorico(historicalPage - 1)" [disabled]="historicalPage === 1"
                  class="px-2.5 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
            <i class="fas fa-angle-left mr-1"></i>Anterior
          </button>
          <span class="px-3 py-1.5 text-sm text-gray-700">
            Página <strong>{{ historicalPage }}</strong> de <strong>{{ historicalPages }}</strong>
          </span>
          <button (click)="irAPaginaHistorico(historicalPage + 1)" [disabled]="historicalPage >= historicalPages"
                  class="px-2.5 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
            Siguiente<i class="fas fa-angle-right ml-1"></i>
          </button>
          <button (click)="irAPaginaHistorico(historicalPages)" [disabled]="historicalPage >= historicalPages"
                  title="Última página"
                  class="px-2.5 py-1.5 text-sm border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoadingHistorical && filteredHistoricalDebits.length === 0" class="bg-white shadow-md rounded-lg p-12 text-center">
        <i class="fas fa-inbox text-gray-400 text-6xl mb-4"></i>
        <h3 class="text-xl font-semibold text-gray-700 mb-2">No hay domiciliaciones históricas</h3>
        <p class="text-gray-500">Ajusta los filtros o buscá directamente por número de lote</p>
      </div>
    </div>

    <!-- Product Config Tab -->
    <div *ngIf="activeTab === 'product-config'">
      <!-- Filters and Actions -->
      <div class="bg-white shadow-md rounded-lg mb-6 p-6">
        <div class="grid md:grid-cols-2 gap-4">
          <!-- Search -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Buscar</label>
            <div class="relative">
              <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input 
                type="text" 
                [(ngModel)]="searchTerm"
                (ngModelChange)="applyFilters()"
                placeholder="Código o nombre del producto..."
                class="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>
          </div>
        </div>
      </div>

    <!-- Loading -->
    <div *ngIf="isLoading" class="bg-white shadow-md rounded-lg p-12 text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
      <p class="text-gray-600">Cargando configuraciones...</p>
    </div>

    <!-- Table -->
    <div *ngIf="!isLoading" class="bg-white shadow-md rounded-lg overflow-hidden">
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left text-gray-500">
          <thead class="text-xs text-gray-700 uppercase bg-gray-50 border-b border-gray-200">
            <tr>
              <th scope="col" class="px-4 py-3">Producto</th>
              <th scope="col" class="px-4 py-3">Bancos permitidos</th>
              <th scope="col" class="px-4 py-3">Tipos permitidos</th>
              <th scope="col" class="px-4 py-3 text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of filteredProducts" 
                class="border-b hover:bg-gray-50 transition-colors">

              <!-- Product Info -->
              <td class="px-4 py-3">
                <div>
                  <div class="font-medium text-gray-900">{{product.name}}</div>
                  <div class="text-xs text-gray-500">{{product.code}}</div>
                  <div class="mt-1">
                    <span 
                      [class]="product.domiciliacion.status ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-500'"
                      class="text-xs font-medium px-2 py-0.5 rounded-full">
                      {{product.domiciliacion.status ? 'Activo' : 'Inactivo'}}
                    </span>
                  </div>
                </div>
              </td>

              <!-- Banks -->
              <td class="px-4 py-3">
                <div class="flex items-center space-x-2">
                  <span 
                    [class]="product.domiciliacion.status ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-500'"
                    class="text-xs font-medium px-2.5 py-0.5 rounded-full">
                    {{getBanksSummary(product)}}
                  </span>
                  <button 
                    *ngIf="product.domiciliacion.status && product.domiciliacion.allowed_banks?.length > 0"
                    class="text-xs text-blue-600 hover:text-blue-800"
                    [title]="getBanksTooltip(product)">
                    <i class="fas fa-info-circle"></i>
                  </button>
                </div>
              </td>

              <!-- Types -->
              <td class="px-4 py-3">
                <div class="flex items-center space-x-2">
                  <span 
                    [class]="product.domiciliacion.status ? 'bg-emerald-100 text-emerald-800' : 'bg-gray-100 text-gray-500'"
                    class="text-xs font-medium px-2.5 py-0.5 rounded-full">
                    {{getTypesSummary(product)}}
                  </span>
                  <button 
                    *ngIf="product.domiciliacion.status && product.domiciliacion.allowed_types?.length > 0"
                    class="text-xs text-emerald-600 hover:text-emerald-800"
                    [title]="getTypesTooltip(product)">
                    <i class="fas fa-info-circle"></i>
                  </button>
                </div>
              </td>

              <!-- Actions -->
              <td class="px-4 py-3 text-center">
                <button 
                  (click)="viewProductDetail(product)"
                  class="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-xs">
                  <i class="fas fa-eye mr-1"></i>Ver
                </button>
              </td>
            </tr>

            <!-- Empty State -->
            <tr *ngIf="filteredProducts.length === 0">
              <td colspan="4" class="px-4 py-12 text-center">
                <i class="fas fa-inbox text-gray-400 text-4xl mb-3"></i>
                <p class="text-gray-600">No se encontraron productos</p>
                <p class="text-sm text-gray-500 mt-1">Intenta ajustar los filtros de búsqueda</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>
    <!-- End Product Config Tab -->

    <!-- Deactivation Log Tab -->
    <div *ngIf="activeTab === 'deactivation-log'">

      <!-- Header y acciones -->
      <div class="bg-white shadow-md rounded-lg mb-6 p-6">
        <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 class="text-lg font-semibold text-gray-800">Bajas por Alta Morosidad</h2>
            <p class="text-sm text-gray-500 mt-1">Clientes con domiciliación desactivada automáticamente por tener más de 60 días de mora.</p>
          </div>
          <div class="flex gap-2">
            <button
              (click)="runDeactivationManual()"
              [disabled]="isRunningDeactivation"
              class="flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
              <i class="fas" [class.fa-ban]="!isRunningDeactivation" [class.fa-spinner]="isRunningDeactivation" [class.fa-spin]="isRunningDeactivation"></i>
              {{ isRunningDeactivation ? 'Ejecutando...' : 'Ejecutar Manual' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Buscador por cédula -->
      <div class="bg-white shadow-md rounded-lg mb-6 p-6">
        <h3 class="text-sm font-semibold text-gray-700 mb-3">Buscar historial por cédula</h3>
        <div class="flex gap-3">
          <input
            type="text"
            [(ngModel)]="deactivationSearchIdentity"
            placeholder="Ej: V12345678"
            class="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500" />
          <button
            (click)="searchDeactivationByIdentity()"
            [disabled]="isSearchingDeactivation"
            class="px-4 py-2 bg-gray-700 text-white rounded-lg text-sm font-medium hover:bg-gray-800 disabled:opacity-50 transition-colors">
            <i class="fas fa-search mr-1"></i>
            Buscar
          </button>
          <button
            *ngIf="deactivationSearchResult"
            (click)="clearDeactivationSearch()"
            class="px-3 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm hover:bg-gray-300 transition-colors">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <!-- Resultado búsqueda -->
        <div *ngIf="deactivationSearchResult" class="mt-4">
          <div *ngIf="deactivationSearchResult.deactivation_history?.length === 0" class="text-sm text-gray-500">
            No se encontraron registros para la cédula <strong>{{ deactivationSearchIdentity }}</strong>.
          </div>
          <div *ngIf="deactivationSearchResult.deactivation_history?.length > 0">
            <p class="text-sm font-medium text-gray-700 mb-3">
              Historial de bajas para <strong>{{ deactivationSearchIdentity }}</strong>:
            </p>
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead class="bg-gray-50 border-b border-gray-200">
                  <tr>
                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Lote</th>
                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Fecha</th>
                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Producto</th>
                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Mora (días)</th>
                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Notificación</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200">
                  <tr *ngFor="let item of deactivationSearchResult.deactivation_history" class="hover:bg-gray-50">
                    <td class="px-4 py-2 font-medium text-gray-900">{{ item.batch_number }}</td>
                    <td class="px-4 py-2 text-gray-600">{{ item.execution_date | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td class="px-4 py-2">
                      <span class="px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">{{ item.record?.product_type || '-' }}</span>
                    </td>
                    <td class="px-4 py-2 text-red-600 font-semibold">{{ item.record?.days_mora || '-' }} días</td>
                    <td class="px-4 py-2">
                      <span *ngIf="item.record?.notification_sent" class="text-green-600"><i class="fas fa-check-circle mr-1"></i>Enviada</span>
                      <span *ngIf="!item.record?.notification_sent" class="text-red-500"><i class="fas fa-times-circle mr-1"></i>No enviada</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- Tabla de batches -->
      <div *ngIf="isLoadingDeactivationBatches" class="text-center py-8 text-gray-500">
        <i class="fas fa-spinner fa-spin mr-2"></i> Cargando procesos...
      </div>

      <div *ngIf="!isLoadingDeactivationBatches">
        <div class="flex items-center justify-between mb-3">
          <span class="text-sm text-gray-600">Total: <strong>{{ deactivationBatchesTotal }}</strong> procesos ejecutados</span>
        </div>

        <div class="bg-white shadow-md rounded-lg overflow-hidden">
          <div class="overflow-x-auto">
            <table class="w-full text-sm">
              <thead class="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase"># Lote</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Fecha</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Productos</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Desactivadas</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Notificadas</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Errores</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Estado</th>
                  <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Acciones</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr *ngIf="deactivationBatches.length === 0">
                  <td colspan="8" class="px-4 py-8 text-center text-gray-400">No se han ejecutado procesos aún</td>
                </tr>
                <tr *ngFor="let batch of deactivationBatches" class="hover:bg-gray-50 transition-colors">
                  <td class="px-4 py-3 font-medium text-gray-900">{{ batch.batch_number }}</td>
                  <td class="px-4 py-3 text-gray-600">{{ batch.execution_date | date:'dd/MM/yyyy HH:mm' }}</td>
                  <td class="px-4 py-3">
                    <span *ngFor="let pt of batch.product_types" class="mr-1 px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">{{ pt }}</span>
                  </td>
                  <td class="px-4 py-3">
                    <span class="font-semibold text-gray-800">{{ batch.total_deactivated }}</span>
                    <span class="text-gray-400 text-xs ml-1">/ {{ batch.total_candidates }}</span>
                  </td>
                  <td class="px-4 py-3 text-gray-700">{{ batch.total_notifications_sent }}</td>
                  <td class="px-4 py-3">
                    <span [class]="batch.total_errors > 0 ? 'text-red-600 font-semibold' : 'text-gray-400'">{{ batch.total_errors }}</span>
                  </td>
                  <td class="px-4 py-3">
                    <span [ngClass]="{
                      'bg-green-100 text-green-800': batch.status === 'COMPLETED',
                      'bg-yellow-100 text-yellow-800': batch.status === 'PARTIAL',
                      'bg-red-100 text-red-800': batch.status === 'FAILED',
                      'bg-blue-100 text-blue-800': batch.status === 'PROCESSING'
                    }" class="px-2.5 py-0.5 rounded-full text-xs font-medium">
                      {{ batch.status }}
                    </span>
                  </td>
                  <td class="px-4 py-3">
                    <div class="flex gap-2">
                      <button
                        (click)="openDeactivationBatchDetail(batch)"
                        class="px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs hover:bg-gray-200 transition-colors"
                        title="Ver detalle">
                        <i class="fas fa-eye"></i>
                      </button>
                      <button
                        (click)="exportDeactivationCsv(batch._id)"
                        class="px-2 py-1 bg-green-100 text-green-700 rounded text-xs hover:bg-green-200 transition-colors"
                        title="Exportar CSV">
                        <i class="fas fa-file-csv"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div *ngIf="deactivationBatchesTotal > deactivationBatchesLimit" class="flex justify-center gap-2 mt-4">
          <button
            (click)="loadDeactivationBatches(deactivationBatchesPage - 1)"
            [disabled]="deactivationBatchesPage <= 1"
            class="px-3 py-1 bg-white border border-gray-300 rounded text-sm disabled:opacity-40">
            Anterior
          </button>
          <span class="px-3 py-1 text-sm text-gray-600">Página {{ deactivationBatchesPage }}</span>
          <button
            (click)="loadDeactivationBatches(deactivationBatchesPage + 1)"
            [disabled]="deactivationBatchesPage * deactivationBatchesLimit >= deactivationBatchesTotal"
            class="px-3 py-1 bg-white border border-gray-300 rounded text-sm disabled:opacity-40">
            Siguiente
          </button>
        </div>
      </div>
    </div>
    <!-- End Deactivation Log Tab -->

    <!-- ══ Alertas Tab ══════════════════════════════════════════════════════ -->
    <!-- Configuración de las alertas de domiciliación en Discord. Existe para poder
         apagarlas o ajustarlas sin redeploy: si en producción empiezan a sonar de más,
         hay que poder cortarlas en el momento. -->
    <div *ngIf="activeTab === 'alerts-config'">

      <div *ngIf="alertsLoading" class="text-center py-12 text-gray-500">
        <i class="fas fa-circle-notch fa-spin mr-2"></i> Cargando configuración…
      </div>

      <!-- Estado de error. Sin esto, un fallo de carga deja la pestaña en blanco
           y sin explicación: el peor resultado posible. -->
      <div *ngIf="!alertsLoading && !alertsConfig" class="max-w-2xl">
        <div class="border border-red-200 bg-red-50 rounded-lg p-6 text-center">
          <i class="fas fa-exclamation-triangle text-red-500 text-2xl mb-3"></i>
          <p class="font-medium text-red-800">No se pudo cargar la configuración de alertas</p>
          <p class="text-sm text-red-700 mt-2" *ngIf="alertsError">{{ alertsError }}</p>
          <p class="text-sm text-gray-600 mt-2">
            Revisa que el backend esté levantado y que tengas permiso sobre domiciliación.
          </p>
          <button (click)="loadAlertsConfig()" type="button"
                  class="mt-4 px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700">
            <i class="fas fa-redo mr-1"></i> Reintentar
          </button>
        </div>
      </div>

      <div *ngIf="!alertsLoading && alertsConfig" class="max-w-4xl">

        <!-- Aviso de ambiente: que nadie apague producción creyendo que toca QA -->
        <div class="flex items-center justify-between mb-4">
          <h2 class="text-lg font-semibold text-gray-900">Alertas de domiciliación</h2>
          <span [class]="alertsEsProduccion
                  ? 'bg-red-100 text-red-700 border-red-200'
                  : 'bg-gray-100 text-gray-600 border-gray-200'"
                class="text-xs font-semibold px-3 py-1 rounded-full border">
            <i class="fas fa-server mr-1"></i>{{ alertsAmbiente }}
          </span>
        </div>

        <!-- Interruptor general -->
        <div [class]="alertsConfig.enabled ? 'border-green-300 bg-green-50' : 'border-gray-300 bg-gray-50'"
             class="border rounded-lg p-4 mb-6">
          <div class="flex items-start justify-between gap-4">
            <div>
              <div class="font-semibold text-gray-900">
                <i class="fas fa-power-off mr-2"></i>
                {{ alertsConfig.enabled ? 'Alertas activas' : 'Alertas apagadas' }}
              </div>
              <p class="text-sm text-gray-600 mt-1">
                Interruptor general. Apagado esto no sale ni un mensaje, sin importar
                los interruptores de cada evento.
              </p>
            </div>
            <button (click)="alertsConfig.enabled = !alertsConfig.enabled; marcarAlertsDirty()"
                    [class]="alertsConfig.enabled ? 'bg-green-600' : 'bg-gray-300'"
                    class="relative inline-flex h-7 w-12 shrink-0 rounded-full transition-colors">
              <span [class]="alertsConfig.enabled ? 'translate-x-6' : 'translate-x-1'"
                    class="inline-block h-5 w-5 mt-1 transform rounded-full bg-white transition-transform"></span>
            </button>
          </div>
        </div>

        <!-- Canal de Discord -->
        <div class="mb-6">
          <label class="block text-sm font-medium text-gray-700 mb-1">Canal de Discord</label>
          <div class="flex gap-2">
            <input [type]="alertsWebhookVisible ? 'text' : 'password'"
                   [(ngModel)]="alertsWebhookNuevo"
                   (ngModelChange)="marcarAlertsDirty()"
                   [placeholder]="alertsConfig.webhook_configurado ? alertsConfig.webhook_url : 'https://discord.com/api/webhooks/…'"
                   class="flex-1 border border-gray-300 rounded-md px-3 py-2 text-sm font-mono">
            <button (click)="alertsWebhookVisible = !alertsWebhookVisible" type="button"
                    class="px-3 border border-gray-300 rounded-md text-gray-600 hover:bg-gray-50">
              <i [class]="alertsWebhookVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
            <button (click)="testAlertsWebhook()"
                    [disabled]="alertsTesting || !puedeProbarWebhook"
                    [title]="puedeProbarWebhook ? 'Envía un mensaje marcado como prueba' : 'Pega primero un webhook para poder probarlo'"
                    type="button"
                    class="px-4 border border-blue-300 text-blue-700 rounded-md text-sm hover:bg-blue-50 disabled:opacity-40 disabled:cursor-not-allowed">
              <i class="fas fa-paper-plane mr-1" *ngIf="!alertsTesting"></i>
              <i class="fas fa-circle-notch fa-spin mr-1" *ngIf="alertsTesting"></i>
              Probar
            </button>
          </div>
          <p class="text-xs text-gray-500 mt-1" *ngIf="alertsConfig.webhook_configurado">
            Se muestra enmascarado. Déjalo vacío para conservar el actual; escribe uno nuevo para reemplazarlo.
          </p>
          <p class="text-xs text-amber-700 mt-1" *ngIf="!alertsConfig.webhook_configurado">
            <i class="fas fa-info-circle mr-1"></i>
            Todavía no hay ningún canal configurado. Pega el webhook aquí y pulsa
            <span class="font-medium">Probar</span> para comprobarlo antes de guardar.
          </p>
          <p *ngIf="alertsConfig.last_test_at" class="text-xs mt-1"
             [class]="alertsConfig.last_test_ok ? 'text-green-700' : 'text-red-700'">
            Última prueba: {{ alertsConfig.last_test_ok ? '✅ enviada' : '❌ falló' }}
            · {{ alertsConfig.last_test_at | date: 'dd/MM/yyyy HH:mm' }}
            <span *ngIf="alertsConfig.last_test_by">por {{ alertsConfig.last_test_by }}</span>
          </p>
        </div>

        <!-- Eventos -->
        <div class="mb-6">
          <div class="flex items-center justify-between pb-2 border-b border-gray-200 mb-2">
            <span class="text-sm font-medium text-gray-700">Eventos</span>
            <div class="flex gap-8 text-xs font-medium text-gray-500">
              <span class="w-12 text-center">Activo</span>
              <span class="w-16 text-center">Menciona</span>
            </div>
          </div>

          <!-- Leyenda de las dos vías. Va una sola vez, arriba: sin esto los badges de
               cada fila no significan nada para quien entra por primera vez. -->
          <div class="flex flex-wrap gap-x-6 gap-y-1 mb-3 text-xs text-gray-600">
            <span>
              <span class="inline-flex items-center px-1.5 py-0.5 rounded bg-amber-100 text-amber-800 font-medium mr-1">
                <i class="fas fa-bolt mr-1 text-[9px]"></i>En caliente
              </span>
              la manda el propio proceso, al instante
            </span>
            <span>
              <span class="inline-flex items-center px-1.5 py-0.5 rounded bg-indigo-100 text-indigo-800 font-medium mr-1">
                <i class="fas fa-binoculars mr-1 text-[9px]"></i>Vigilante
              </span>
              la descubre el barrido, cada 5 min
            </span>
          </div>

          <div *ngFor="let ev of alertsEventos" class="border-b border-gray-100 last:border-0">
          <div class="flex items-center justify-between py-2.5">
            <div class="pr-4 min-w-0">
              <div class="flex items-center flex-wrap gap-x-2 gap-y-1">
                <span class="text-sm font-medium text-gray-900">{{ ev.icono }} {{ ev.nombre }}</span>

                <!-- Vía: lo primero que hay que saber cuando una alerta no llega -->
                <span *ngIf="ev.via === 'caliente'"
                      class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-800"
                      title="La emite el propio proceso de conciliación, al instante">
                  <i class="fas fa-bolt mr-1 text-[9px]"></i>En caliente
                </span>
                <span *ngIf="ev.via === 'vigilante'"
                      class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-indigo-100 text-indigo-800"
                      title="La descubre el barrido periódico, hasta 5 minutos después">
                  <i class="fas fa-binoculars mr-1 text-[9px]"></i>Vigilante
                </span>

                <span *ngIf="ev.repite"
                      class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-gray-600"
                      title="Insiste a los 30 min, 1 h, 2 h y 4 h; se silencia a las 12 h">
                  <i class="fas fa-redo mr-1 text-[9px]"></i>Insiste
                </span>
              </div>
              <div class="text-xs text-gray-500 mt-0.5">{{ ev.desc }}</div>
              <button type="button" (click)="toggleDetalleEvento(ev.key)"
                      class="text-[11px] text-blue-600 hover:underline mt-1">
                <i class="fas mr-1" [ngClass]="alertsEventoAbierto === ev.key ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                {{ alertsEventoAbierto === ev.key ? 'Ocultar detalle' : 'Qué detecta y qué implica' }}
              </button>
            </div>
            <div class="flex gap-8 items-center shrink-0">
              <button (click)="toggleEvento(ev.key, 'enabled')"
                      [class]="eventoConfig(ev.key).enabled ? 'bg-green-600' : 'bg-gray-300'"
                      class="relative inline-flex h-6 w-11 rounded-full transition-colors">
                <span [class]="eventoConfig(ev.key).enabled ? 'translate-x-5' : 'translate-x-1'"
                      class="inline-block h-4 w-4 mt-1 transform rounded-full bg-white transition-transform"></span>
              </button>
              <button (click)="toggleEvento(ev.key, 'mention')"
                      [disabled]="!eventoConfig(ev.key).enabled"
                      [class]="eventoConfig(ev.key).mention ? 'bg-orange-500' : 'bg-gray-300'"
                      class="relative inline-flex h-6 w-11 rounded-full transition-colors disabled:opacity-40 ml-2">
                <span [class]="eventoConfig(ev.key).mention ? 'translate-x-5' : 'translate-x-1'"
                      class="inline-block h-4 w-4 mt-1 transform rounded-full bg-white transition-transform"></span>
              </button>
            </div>
          </div>

          <!-- Detalle desplegable: qué la dispara, qué significa y cuándo llega -->
          <div *ngIf="alertsEventoAbierto === ev.key"
               class="pb-3 pl-1 pr-4 -mt-1 space-y-2 text-xs">
            <div class="bg-gray-50 border border-gray-200 rounded-lg p-3 space-y-2">
              <div>
                <div class="font-semibold text-gray-700 mb-0.5">
                  <i class="fas fa-crosshairs mr-1 text-gray-400"></i>Qué detecta
                </div>
                <div class="text-gray-600">{{ ev.detecta }}</div>
              </div>
              <div>
                <div class="font-semibold text-gray-700 mb-0.5">
                  <i class="fas fa-exclamation-circle mr-1 text-gray-400"></i>Qué implica
                </div>
                <div class="text-gray-600">{{ ev.implica }}</div>
              </div>
              <div>
                <div class="font-semibold text-gray-700 mb-0.5">
                  <i class="far fa-clock mr-1 text-gray-400"></i>Cuándo llega
                </div>
                <div class="text-gray-600">{{ ev.cuando }}</div>
              </div>
            </div>
          </div>
          </div>
          <p class="text-xs text-gray-500 mt-2">
            "Menciona" hace sonar un <span class="font-mono">&#64;here</span> en el canal. La queja
            habitual no suele ser que sobren alertas, sino que suene la mención de más.
          </p>
        </div>

        <!-- Ajustes finos -->
        <div class="mb-6">
          <button (click)="alertsMostrarAjustes = !alertsMostrarAjustes" type="button"
                  class="text-sm text-blue-600 hover:underline">
            <i [class]="alertsMostrarAjustes ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="mr-1"></i>
            Ajustes finos
          </button>

          <div *ngIf="alertsMostrarAjustes" class="mt-3 pl-4 border-l-2 border-gray-200 space-y-3">
            <div class="flex items-center gap-2 text-sm">
              <span class="text-gray-700 w-44">Trabado a partir de:</span>
              <span class="text-gray-500">estimado ×</span>
              <input type="number" min="1" max="20" [(ngModel)]="alertsConfig.stuck_factor"
                     (ngModelChange)="marcarAlertsDirty()"
                     class="w-16 border border-gray-300 rounded px-2 py-1 text-sm">
              <span class="text-gray-500">con un piso de</span>
              <input type="number" min="1" max="240" [(ngModel)]="alertsConfig.stuck_min_minutes"
                     (ngModelChange)="marcarAlertsDirty()"
                     class="w-16 border border-gray-300 rounded px-2 py-1 text-sm">
              <span class="text-gray-500">min</span>
            </div>

            <div class="flex items-center gap-2 text-sm">
              <span class="text-gray-700 w-44">Recordatorios:</span>
              <button (click)="alertsConfig.reminders_enabled = !alertsConfig.reminders_enabled; marcarAlertsDirty()"
                      [class]="alertsConfig.reminders_enabled ? 'bg-green-600' : 'bg-gray-300'"
                      class="relative inline-flex h-6 w-11 rounded-full transition-colors">
                <span [class]="alertsConfig.reminders_enabled ? 'translate-x-5' : 'translate-x-1'"
                      class="inline-block h-4 w-4 mt-1 transform rounded-full bg-white transition-transform"></span>
              </button>
              <span class="text-gray-500">a los 30 min, 1 h, 2 h y 4 h (solo críticas)</span>
            </div>

            <div class="flex items-center gap-2 text-sm">
              <span class="text-gray-700 w-44">Silenciar tras:</span>
              <input type="number" min="1" max="72" [(ngModel)]="alertsConfig.mute_after_hours"
                     (ngModelChange)="marcarAlertsDirty()"
                     class="w-16 border border-gray-300 rounded px-2 py-1 text-sm">
              <span class="text-gray-500">h sin resolverse</span>
            </div>
            <p class="text-xs text-gray-500">
              Pasado ese tiempo la alerta deja de sonar aunque siga sin resolverse: insistir
              más allá solo tapa lo nuevo.
            </p>
          </div>
        </div>

        <!-- Mensaje de resultado -->
        <div *ngIf="alertsMensaje"
             [class]="alertsMensaje.tipo === 'ok' ? 'bg-green-50 text-green-800 border-green-200' : 'bg-red-50 text-red-800 border-red-200'"
             class="border rounded-md px-3 py-2 text-sm mb-4">
          {{ alertsMensaje.texto }}
        </div>

        <!-- Pie -->
        <div class="flex items-center justify-between pt-4 border-t border-gray-200">
          <span class="text-xs text-gray-500">
            <span *ngIf="alertsConfig.updated_by">Último cambio: {{ alertsConfig.updated_by }}</span>
            <span *ngIf="alertsConfig.updated_at"> · {{ alertsConfig.updated_at | date: 'dd/MM/yyyy HH:mm' }}</span>
            <span *ngIf="alertsConfig._origen" class="italic"> ({{ alertsConfig._origen }})</span>
          </span>
          <div class="flex gap-2">
            <button (click)="loadAlertsConfig()" [disabled]="alertsSaving" type="button"
                    class="px-4 py-2 text-sm border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 disabled:opacity-50">
              Descartar
            </button>
            <button (click)="saveAlertsConfig()" [disabled]="alertsSaving || !alertsDirty" type="button"
                    class="px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50">
              <i class="fas fa-circle-notch fa-spin mr-1" *ngIf="alertsSaving"></i>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Alertas Tab -->

    <!-- Cobros Reader Tab — Oculto temporalmente (en revisión)
    <div *ngIf="activeTab === 'cobros-reader'">
      <app-cobros-reader></app-cobros-reader>
    </div>
    End Cobros Reader Tab -->

  </div>
</div>

<!-- Modal: Detalle de Batch de Baja por Morosidad -->
<div *ngIf="showDeactivationDetailModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center p-4">
  <div class="relative bg-white rounded-lg shadow-xl w-full max-w-5xl">
    <div class="flex items-center justify-between p-6 border-b border-gray-200">
      <div>
        <h3 class="text-xl font-semibold text-gray-900">
          Detalle del Lote: {{ selectedDeactivationBatch?.batch_number }}
        </h3>
        <p class="text-sm text-gray-500 mt-1">
          {{ selectedDeactivationBatch?.execution_date | date:'dd/MM/yyyy HH:mm' }} &bull;
          Productos: {{ selectedDeactivationBatch?.product_types?.join(', ') }} &bull;
          Umbral: {{ selectedDeactivationBatch?.mora_threshold_days }} días
        </p>
      </div>
      <button (click)="closeDeactivationDetailModal()" class="text-gray-400 hover:text-gray-600">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <div class="p-6">
      <!-- Estadísticas del batch -->
      <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div class="bg-gray-50 rounded-lg p-3 text-center">
          <div class="text-2xl font-bold text-gray-800">{{ selectedDeactivationBatchDetail?.total_candidates }}</div>
          <div class="text-xs text-gray-500 mt-1">Candidatos</div>
        </div>
        <div class="bg-red-50 rounded-lg p-3 text-center">
          <div class="text-2xl font-bold text-red-700">{{ selectedDeactivationBatchDetail?.total_deactivated }}</div>
          <div class="text-xs text-gray-500 mt-1">Desactivadas</div>
        </div>
        <div class="bg-green-50 rounded-lg p-3 text-center">
          <div class="text-2xl font-bold text-green-700">{{ selectedDeactivationBatchDetail?.total_notifications_sent }}</div>
          <div class="text-xs text-gray-500 mt-1">Notificadas</div>
        </div>
        <div class="bg-yellow-50 rounded-lg p-3 text-center">
          <div class="text-2xl font-bold text-yellow-700">{{ selectedDeactivationBatchDetail?.total_errors }}</div>
          <div class="text-xs text-gray-500 mt-1">Errores</div>
        </div>
      </div>

      <!-- Buscador dentro del batch -->
      <div *ngIf="!isLoadingDeactivationDetail" class="flex gap-2 mb-3">
        <input
          type="text"
          [(ngModel)]="affectedPersonsSearch"
          placeholder="Buscar por cédula..."
          (keyup.enter)="searchAffectedPersonsInBatch()"
          class="flex-1 border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500" />
        <button
          (click)="searchAffectedPersonsInBatch()"
          [disabled]="isSearchingPersons"
          class="px-3 py-1.5 bg-gray-700 text-white rounded-lg text-sm hover:bg-gray-800 disabled:opacity-50 transition-colors">
          <i class="fas fa-search"></i>
        </button>
        <button
          *ngIf="affectedPersonsSearch"
          (click)="clearAffectedPersonsSearch()"
          class="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-lg text-sm hover:bg-gray-300 transition-colors">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Loading inicial -->
      <div *ngIf="isLoadingDeactivationDetail" class="text-center py-8 text-gray-500">
        <i class="fas fa-spinner fa-spin mr-2"></i> Cargando...
      </div>

      <!-- Tabla paginada de personas afectadas -->
      <div *ngIf="!isLoadingDeactivationDetail" class="overflow-x-auto max-h-80 overflow-y-auto">
        <div class="flex items-center justify-between mb-2">
          <span class="text-xs text-gray-500">
            Mostrando <strong>{{ affectedPersonsData.length }}</strong> de <strong>{{ affectedPersonsTotal }}</strong> registros
          </span>
        </div>
        <table class="w-full text-sm">
          <thead class="bg-gray-50 border-b border-gray-200 sticky top-0">
            <tr>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Cédula</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Nombre y Apellido</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Código</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Producto</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Banco</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Cuenta</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Mora</th>
              <th class="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase">Notif.</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <tr *ngIf="affectedPersonsData.length === 0 && !isLoadingMorePersons">
              <td colspan="8" class="px-4 py-6 text-center text-gray-400 text-sm">Sin registros</td>
            </tr>
            <tr *ngFor="let p of affectedPersonsData" class="hover:bg-gray-50">
              <td class="px-4 py-2 font-medium text-gray-900">{{ p.identity || '-' }}</td>
              <td class="px-4 py-2 text-gray-700">{{ p.name || '-' }}</td>
              <td class="px-4 py-2 text-gray-500 text-xs">{{ p.person_code || '-' }}</td>
              <td class="px-4 py-2">
                <span class="px-2 py-0.5 rounded-full text-xs bg-blue-100 text-blue-800">{{ p.product_type }}</span>
              </td>
              <td class="px-4 py-2 text-gray-600">{{ p.bank_name || '-' }}</td>
              <td class="px-4 py-2 text-gray-500 text-xs">{{ p.account_number || '-' }}</td>
              <td class="px-4 py-2 text-red-600 font-semibold">{{ p.days_mora }} días</td>
              <td class="px-4 py-2">
                <span *ngIf="p.notification_sent" class="text-green-600" title="Notificación enviada"><i class="fas fa-check-circle"></i></span>
                <span *ngIf="!p.notification_sent" class="text-red-500" [title]="p.notification_error || 'No enviada'"><i class="fas fa-times-circle"></i></span>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Botón Ver más -->
        <div class="mt-3 text-center">
          <div *ngIf="isLoadingMorePersons" class="text-sm text-gray-500 py-2">
            <i class="fas fa-spinner fa-spin mr-1"></i> Cargando...
          </div>
          <button
            *ngIf="hasMoreAffectedPersons && !isLoadingMorePersons"
            (click)="loadMoreAffectedPersons()"
            class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg text-sm hover:bg-gray-200 transition-colors">
            <i class="fas fa-chevron-down mr-1"></i>
            Ver {{ affectedPersonsTotal - affectedPersonsData.length > affectedPersonsLimit ? affectedPersonsLimit : affectedPersonsTotal - affectedPersonsData.length }} más
            ({{ affectedPersonsTotal - affectedPersonsData.length }} restantes)
          </button>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-3 p-6 border-t border-gray-200">
      <button
        (click)="exportDeactivationCsv(selectedDeactivationBatch?._id)"
        class="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 transition-colors">
        <i class="fas fa-file-csv"></i>
        Exportar CSV
      </button>
      <button
        (click)="closeDeactivationDetailModal()"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-300 transition-colors">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Bulk Edit Modal -->
<div *ngIf="showBulkEditModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
  <div class="relative bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4">
    <!-- Modal Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200">
      <h3 class="text-xl font-semibold text-gray-900">
        Edición Masiva
      </h3>
      <button (click)="closeBulkEditModal()" class="text-gray-400 hover:text-gray-600">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="p-6 space-y-6">
      <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
        <p class="text-sm text-blue-800">
          <i class="fas fa-info-circle mr-2"></i>
          Se aplicarán los cambios a {{selectedProducts.size}} producto(s) seleccionado(s)
        </p>
      </div>

      <!-- Action Type -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Tipo de acción</label>
        <select 
          [(ngModel)]="bulkAction"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
          <option value="add">Agregar a la configuración existente</option>
          <option value="replace">Reemplazar configuración completa</option>
          <option value="remove">Remover de la configuración</option>
        </select>
      </div>

      <!-- Banks Selection -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Bancos</label>
        <div class="border rounded-md p-3 max-h-40 overflow-auto bg-gray-50">
          <label *ngFor="let bank of banksList" class="flex items-center space-x-2 mb-2">
            <input 
              type="checkbox" 
              [value]="bank.code" 
              [(ngModel)]="bulkBanksToAdd"
              [ngModelOptions]="{standalone: true}"
              class="rounded">
            <span class="text-sm text-gray-700">{{bank.name}} ({{bank.code}})</span>
          </label>
        </div>
      </div>

      <!-- Types Selection -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Tipos</label>
        <div class="border rounded-md p-3 bg-gray-50">
          <label *ngFor="let type of domiciliationTypes" class="flex items-center space-x-2 mb-2">
            <input 
              type="checkbox" 
              [value]="type.id" 
              [(ngModel)]="bulkTypesToAdd"
              [ngModelOptions]="{standalone: true}"
              class="rounded">
            <span class="text-sm text-gray-700">{{type.name}}</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
      <button 
        (click)="closeBulkEditModal()" 
        class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors">
        Cancelar
      </button>
      <button 
        (click)="applyBulkEdit()" 
        [disabled]="isLoading"
        class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
        <i *ngIf="isLoading" class="fas fa-spinner fa-spin mr-2"></i>
        <i *ngIf="!isLoading" class="fas fa-check mr-2"></i>
        Aplicar cambios
      </button>
    </div>
  </div>
</div>

<!-- Detail View Modal -->
<div *ngIf="showDetailModal && selectedProductDetail" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
  <div class="relative bg-white rounded-lg shadow-xl max-w-3xl w-full mx-4">
    <!-- Modal Header -->
    <div class="flex items-center justify-between p-6 border-b border-gray-200">
      <div>
        <h3 class="text-xl font-semibold text-gray-900">
          {{selectedProductDetail.name}}
        </h3>
        <p class="text-sm text-gray-500 mt-1">{{selectedProductDetail.code}}</p>
      </div>
      <button (click)="closeDetailModal()" class="text-gray-400 hover:text-gray-600">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="p-6 space-y-6">
      <!-- Estado -->
      <div class="bg-gray-50 rounded-lg p-4">
        <div class="flex items-center justify-between">
          <h4 class="font-semibold text-gray-800">Estado de Domiciliación</h4>
          <span 
            [class]="selectedProductDetail.domiciliacion.status ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-500'"
            class="text-sm font-medium px-3 py-1 rounded-full">
            {{selectedProductDetail.domiciliacion.status ? 'Activo' : 'Inactivo'}}
          </span>
        </div>
      </div>

      <!-- Bancos -->
      <div>
        <h4 class="font-semibold text-gray-800 mb-3">Bancos Permitidos</h4>
        <div *ngIf="selectedProductDetail.domiciliacion.allowed_banks && selectedProductDetail.domiciliacion.allowed_banks.length > 0; else allBanks" 
             class="flex flex-wrap gap-2">
          <span *ngFor="let code of selectedProductDetail.domiciliacion.allowed_banks" 
                class="inline-flex items-center px-3 py-1.5 bg-blue-50 text-blue-700 rounded-full text-sm font-medium border border-blue-200">
            {{getBankName(code)}}
          </span>
        </div>
        <ng-template #allBanks>
          <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r">
            <p class="text-sm text-blue-800">
              <i class="fas fa-info-circle mr-2"></i>
              Todos los bancos están permitidos (sin restricción)
            </p>
          </div>
        </ng-template>
      </div>

      <!-- Tipos -->
      <div>
        <h4 class="font-semibold text-gray-800 mb-3">Tipos Permitidos</h4>
        <div *ngIf="selectedProductDetail.domiciliacion.allowed_types && selectedProductDetail.domiciliacion.allowed_types.length > 0; else allTypes" 
             class="flex flex-wrap gap-2">
          <span *ngFor="let id of selectedProductDetail.domiciliacion.allowed_types" 
                class="inline-flex items-center px-3 py-1.5 bg-emerald-50 text-emerald-700 rounded-full text-sm font-medium border border-emerald-200">
            {{getTypeName(id)}}
          </span>
        </div>
        <ng-template #allTypes>
          <div class="bg-emerald-50 border-l-4 border-emerald-500 p-4 rounded-r">
            <p class="text-sm text-emerald-800">
              <i class="fas fa-info-circle mr-2"></i>
              Todos los tipos están permitidos (sin restricción)
            </p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
      <button 
        (click)="closeDetailModal()" 
        class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Timeline Modal -->
<div *ngIf="showTimelineModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
  <div class="relative bg-white rounded-lg shadow-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
    <!-- Modal Header -->
    <div class="sticky top-0 bg-white flex items-start justify-between p-6 border-b border-gray-200 z-10">
      <div>
        <h3 class="text-xl font-semibold text-gray-900 flex items-center">
          <i class="fas fa-history mr-3 text-blue-600"></i>
          Timeline de Domiciliación
        </h3>
        <p class="text-sm text-gray-500 mt-1">
          <span class="font-semibold">Lote:</span> {{selectedDirectDebit?.lote || selectedDirectDebit?.manual_lote}}
          <span *ngIf="selectedDirectDebit?.params?.special_flow"
                class="ms-2 inline-flex items-center px-2 py-0.5 rounded text-[11px] font-semibold"
                style="background-color:#dbeafe;color:#1e40af;">
            Flujo Especial
          </span>
        </p>
        <div class="flex gap-3 mt-2">
          <span class="text-xs text-gray-600">
            <i class="fas fa-tag mr-1"></i>{{selectedDirectDebit?.type_name}}
          </span>
          <span class="text-xs text-gray-600">
            <i class="fas fa-university mr-1"></i>{{selectedDirectDebit?.bank?.name}}
          </span>
          <span class="text-xs text-gray-600">
            <i class="fas fa-coins mr-1"></i>{{selectedDirectDebit?.total_amount | number:'1.2-2'}}
          </span>
        </div>
      </div>
      <button (click)="closeTimelineModal()" class="text-gray-400 hover:text-gray-600">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <!-- Modal Body -->
    <div class="p-6">
      <!-- Loading -->
      <div *ngIf="loadingTimeline" class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>

      <!-- Resumen de ejecución: responde "¿qué pasó acá?" sin leer el detalle -->
      <div *ngIf="!loadingTimeline && timelineSummary" class="grid grid-cols-2 md:grid-cols-4 gap-2 mb-6">
        <div class="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
          <div class="text-[10px] font-bold uppercase tracking-wide text-gray-500">Duración total</div>
          <div class="text-base font-bold mt-0.5">{{ totalDuration() }}</div>
          <div class="text-[11px] text-gray-500">{{ formatDate(timelineSummary.first_event) }}</div>
        </div>
        <div class="bg-gray-50 border border-gray-200 rounded-lg px-3 py-2">
          <div class="text-[10px] font-bold uppercase tracking-wide text-gray-500">Generación</div>
          <div class="text-base font-bold mt-0.5">{{ timelineSummary.generation_runs }} ejecución(es)</div>
        </div>
        <div class="rounded-lg px-3 py-2 border"
             [ngClass]="timelineSummary.conciliation_failed > 0 ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-gray-200'">
          <div class="text-[10px] font-bold uppercase tracking-wide text-gray-500">Conciliación</div>
          <div class="text-base font-bold mt-0.5"
               [ngClass]="timelineSummary.conciliation_failed > 0 ? 'text-red-700' : ''">
            {{ timelineSummary.conciliation_runs }} intento(s)
          </div>
          <div class="text-[11px] text-gray-500" *ngIf="timelineSummary.conciliation_failed > 0">
            {{ timelineSummary.conciliation_failed }} fallido(s)
          </div>
        </div>
        <div class="rounded-lg px-3 py-2 border"
             [ngClass]="timelineSummary.has_overlap ? 'bg-amber-50 border-amber-200' : 'bg-gray-50 border-gray-200'">
          <div class="text-[10px] font-bold uppercase tracking-wide text-gray-500">Solapamiento</div>
          <div class="text-base font-bold mt-0.5" [ngClass]="timelineSummary.has_overlap ? 'text-amber-700' : ''">
            {{ timelineSummary.has_overlap ? 'Sí' : 'No' }}
          </div>
          <div class="text-[11px] text-gray-500" *ngIf="timelineSummary.has_overlap">
            Hubo conciliaciones simultáneas
          </div>
        </div>
      </div>

      <!-- Timeline -->
      <div *ngIf="!loadingTimeline && timelineMerged.length > 0" class="relative">

        <div *ngFor="let item of timelineMerged; let i = index; let last = last"
             class="relative pl-14" [class.pb-6]="!last">
          <!-- Línea conectora -->
          <div *ngIf="!last" class="absolute left-4 top-9 bottom-0 w-0.5 bg-gray-200"></div>

          <!-- ═══ Cambio de estado del lote ═══ -->
          <ng-container *ngIf="item.kind === 'EVENT'">
            <div [class]="getStatusColor(item.event.status)"
                 class="absolute left-0 w-8 h-8 rounded-full flex items-center justify-center text-xs">
              <i [class]="'fas ' + getStatusIcon(item.event.status)"></i>
            </div>

            <div class="flex flex-wrap items-baseline gap-x-2 gap-y-1 pt-1">
              <span class="font-semibold text-gray-900 text-sm">{{ getStatusShort(item.event.status) }}</span>
              <span class="text-xs text-gray-500">{{ formatDate(item.event.date) }}</span>
              <span *ngIf="item.event.user" class="text-xs text-gray-500">
                <i class="fas fa-user mr-1"></i>{{ item.event.user.name }} {{ item.event.user.lastName }}
                <span class="text-gray-400">(&#64;{{ item.event.user.username }})</span>
              </span>
            </div>
            <div class="text-xs text-gray-500 mt-0.5">{{ getStatusLabel(item.event.status) }}</div>

            <!-- Archivos -->
            <div *ngIf="item.event.url || item.event.url_failed || item.event.url_resume"
                 class="flex flex-wrap gap-x-4 gap-y-1 mt-2">
              <button *ngIf="item.event.url"
                      (click)="downloadFile(item.event.url, 'txt', 'archivo_principal_' + selectedDirectDebit?.lote)"
                      class="text-xs text-blue-600 hover:underline bg-transparent border-none p-0 cursor-pointer">
                <i class="fas fa-file-download mr-1"></i>Archivo principal
              </button>
              <button *ngIf="item.event.url_failed"
                      (click)="downloadFile(item.event.url_failed, 'txt', 'reporte_errores_' + selectedDirectDebit?.lote)"
                      class="text-xs text-red-600 hover:underline bg-transparent border-none p-0 cursor-pointer">
                <i class="fas fa-exclamation-triangle mr-1"></i>Reporte de errores
              </button>
              <button *ngIf="item.event.url_resume"
                      (click)="downloadFile(item.event.url_resume, 'txt', 'resumen_' + selectedDirectDebit?.lote)"
                      class="text-xs text-green-600 hover:underline bg-transparent border-none p-0 cursor-pointer">
                <i class="fas fa-file-alt mr-1"></i>Resumen
              </button>
            </div>

            <div *ngIf="item.event.negociation_code" class="mt-2 text-xs">
              <span class="text-gray-500">Código de negociación:</span>
              <span class="ml-1 font-mono bg-gray-100 px-1.5 py-0.5 rounded">{{ item.event.negociation_code }}</span>
            </div>

            <!-- Archivos de respuesta del banco, uno por intento. Antes se leían y se
                 descartaban: al fallar la conciliación no había forma de recuperar el
                 archivo ni de saber cuál se usó en cada reintento.

                 Va en "Cargado al banco" y NO en "Procesar respuesta" a propósito: ese
                 evento solo se crea cuando la conciliación termina bien, así que
                 justo cuando falla —el caso que importa— no existiría dónde pintarlo. -->
            <div *ngIf="item.event.status === 'UPLOADED' && timelineArchivos.length"
                 class="mt-3 border border-gray-200 bg-gray-50 rounded-md p-2.5">
              <div class="text-xs font-semibold text-gray-800 mb-2">
                <i class="fas fa-file-import mr-1"></i>
                Archivos del banco cargados ({{ timelineArchivos.length }})
              </div>
              <div *ngFor="let a of timelineArchivos"
                   class="text-xs py-1.5 border-t border-gray-200 first:border-0">
                <div class="flex items-center gap-2 flex-wrap">
                  <span class="font-semibold">Intento {{ a.attempt }}</span>
                  <span [ngClass]="{
                          'bg-green-100 text-green-800': a.result === 'COMPLETE',
                          'bg-red-100 text-red-800': a.result === 'ERROR',
                          'bg-gray-200 text-gray-700': a.result === 'PENDING'
                        }"
                        class="px-1.5 rounded text-[10px] font-semibold">
                    {{ a.result === 'COMPLETE' ? 'CONCILIÓ' : a.result === 'ERROR' ? 'FALLÓ' : 'EN CURSO' }}
                  </span>
                  <!-- Descarga por el método estándar y no con un href directo a
                       Cloudinary: extensionRealDeUrl deduce la extensión verdadera, de lo
                       contrario el archivo de Bancaribe (Excel) se baja como .txt y se
                       abre como binario ilegible. -->
                  <button *ngIf="a.url" type="button"
                          (click)="descargarArchivoRespuesta(a)"
                          class="text-blue-600 hover:underline bg-transparent border-0 p-0 cursor-pointer">
                    <i class="fas fa-download mr-1"></i>{{ a.file_name }}
                  </button>
                  <span *ngIf="!a.url" class="text-amber-700" [title]="a.upload_error">
                    <i class="fas fa-exclamation-triangle mr-1"></i>{{ a.file_name }} (sin respaldo)
                  </span>
                </div>
                <div class="flex flex-wrap items-center gap-x-3 mt-0.5 text-gray-600">
                  <span><i class="far fa-clock mr-1"></i>{{ a.at | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                  <span><i class="fas fa-user mr-1"></i>{{ a.by || 'sin registro' }}</span>
                  <span *ngIf="a.size_bytes">{{ (a.size_bytes / 1024).toFixed(0) }} KB</span>
                </div>
                <div *ngIf="a.result_description" class="text-red-700 mt-0.5">{{ a.result_description }}</div>
              </div>
            </div>

            <!-- Traza de cambios manuales. Va en "Cargado al banco" porque es el momento
                 en que el número del banco entra en juego: con ese número se identifica
                 el lote frente al banco, y corregirlo después hay que poder explicarlo. -->
            <div *ngIf="item.event.status === 'UPLOADED' && timelineCambios.length"
                 class="mt-3 border border-amber-200 bg-amber-50 rounded-md p-2.5">
              <div class="text-xs font-semibold text-amber-900 mb-2">
                <i class="fas fa-user-edit mr-1"></i>
                Cambios manuales sobre el lote ({{ timelineCambios.length }})
              </div>
              <div *ngFor="let c of timelineCambios"
                   class="text-xs py-1.5 border-t border-amber-100 first:border-0">
                <div class="text-gray-800">{{ c.description }}</div>
                <div class="flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-0.5 text-gray-600">
                  <span><i class="far fa-clock mr-1"></i>{{ c.at | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                  <span><i class="fas fa-user mr-1"></i>{{ c.by || 'sin registro' }}</span>
                  <span class="font-mono bg-white border border-amber-200 px-1.5 rounded">
                    {{ c.from === null || c.from === undefined ? '(vacío)' : c.from }}
                    →
                    {{ c.to }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- ═══ Ejecución real (trace) ═══ -->
          <ng-container *ngIf="item.kind === 'RUN'">
            <div class="absolute left-0 w-8 h-8 rounded-full flex items-center justify-center text-xs"
                 [ngClass]="item.run.state === 'COMPLETE' ? 'bg-green-100 text-green-700' : 'bg-cyan-100 text-cyan-700'">
              <i class="fas" [ngClass]="item.run.kind === 'GENERATION' ? 'fa-cogs' : 'fa-sync-alt'"></i>
            </div>

            <div class="border rounded-lg overflow-hidden"
                 [ngClass]="item.run.state === 'COMPLETE' ? 'border-green-200' : 'border-gray-200'">
              <div class="flex flex-wrap items-center justify-between gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200">
                <span class="text-sm font-bold">{{ runTitle(item.run) }}</span>
                <span class="text-[11px] font-bold px-2 py-0.5 rounded-full"
                      [ngClass]="item.run.state === 'COMPLETE' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'">
                  {{ item.run.state === 'COMPLETE' ? 'Completado' : item.run.state }}
                </span>
              </div>
              <div class="px-3 py-2">
                <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
                  <div>
                    <div class="text-[10px] font-bold uppercase text-gray-500">Inicio</div>
                    <div class="text-xs font-semibold">{{ formatDate(item.run.date_start) }}</div>
                  </div>
                  <div>
                    <div class="text-[10px] font-bold uppercase text-gray-500">Fin</div>
                    <div class="text-xs font-semibold">{{ item.run.date_end ? formatDate(item.run.date_end) : 'En curso' }}</div>
                  </div>
                  <div>
                    <div class="text-[10px] font-bold uppercase text-gray-500">Duración</div>
                    <div class="text-xs font-semibold">{{ formatDuration(item.run.duration_ms) }}</div>
                  </div>
                  <div>
                    <div class="text-[10px] font-bold uppercase text-gray-500">Ejecutó</div>
                    <div class="text-xs font-semibold">
                      <span *ngIf="runAuthor(item.run)">{{ runAuthor(item.run) }}</span>
                      <span *ngIf="!runAuthor(item.run)" class="text-red-700 italic font-normal">sin registro</span>
                    </div>
                  </div>
                </div>

                <div *ngIf="item.run.progress && item.run.progress.total > 0" class="mt-2">
                  <div class="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                    <div class="h-full rounded-full bg-green-500" [style.width.%]="runPercentage(item.run)"></div>
                  </div>
                  <div class="flex justify-between text-[11px] text-gray-500 mt-1">
                    <span>
                      {{ item.run.progress.processed }} de {{ item.run.progress.total }} pagos
                      · {{ item.run.progress.failed }} fallidos · {{ item.run.progress.skipped }} omitidos
                    </span>
                    <span>{{ runPercentage(item.run) }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- ═══ Intentos fallidos, agrupados ═══ -->
          <ng-container *ngIf="item.kind === 'FAILED_GROUP'">
            <div class="absolute left-0 w-8 h-8 rounded-full flex items-center justify-center text-xs bg-red-100 text-red-700">
              <i class="fas fa-redo"></i>
            </div>

            <div class="border border-dashed border-gray-300 rounded-lg px-3 py-2 bg-gray-50">
              <div class="flex items-center justify-between gap-2 cursor-pointer"
                   (click)="failedAttemptsCollapsed = !failedAttemptsCollapsed">
                <span class="text-sm font-semibold">
                  <i class="fas fa-exclamation-triangle text-red-600 mr-1"></i>
                  {{ item.runs.length }} intento(s) de conciliación sin completar
                </span>
                <i class="fas text-gray-400" [ngClass]="failedAttemptsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
              </div>

              <div *ngIf="!failedAttemptsCollapsed" class="mt-2 space-y-2">
                <div *ngFor="let run of item.runs" class="border border-red-200 rounded-lg overflow-hidden bg-white">
                  <div class="flex flex-wrap items-center justify-between gap-2 px-3 py-2 bg-gray-50 border-b border-gray-200">
                    <span class="text-sm font-bold">{{ runTitle(run) }}</span>
                    <span class="text-[11px] font-bold px-2 py-0.5 rounded-full bg-red-100 text-red-700">
                      {{ run.state === 'ERROR' ? 'Interrumpido' : run.state }}
                    </span>
                  </div>
                  <div class="px-3 py-2">
                    <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
                      <div>
                        <div class="text-[10px] font-bold uppercase text-gray-500">Inicio</div>
                        <div class="text-xs font-semibold">{{ formatDate(run.date_start) }}</div>
                      </div>
                      <div>
                        <div class="text-[10px] font-bold uppercase text-gray-500">Fin</div>
                        <div class="text-xs font-semibold">{{ run.date_end ? formatDate(run.date_end) : '—' }}</div>
                      </div>
                      <div>
                        <div class="text-[10px] font-bold uppercase text-gray-500">Duración</div>
                        <div class="text-xs font-semibold">{{ formatDuration(run.duration_ms) }}</div>
                      </div>
                      <div>
                        <div class="text-[10px] font-bold uppercase text-gray-500">Reinició</div>
                        <div class="text-xs font-semibold">
                          <span *ngIf="runAuthor(run)">{{ runAuthor(run) }}</span>
                          <span *ngIf="!runAuthor(run)" class="text-red-700 italic font-normal">sin registro</span>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="run.progress && run.progress.total > 0" class="mt-2">
                      <div class="h-1.5 bg-gray-200 rounded-full overflow-hidden">
                        <div class="h-full rounded-full bg-red-500" [style.width.%]="runPercentage(run)"></div>
                      </div>
                      <div class="flex justify-between text-[11px] text-gray-500 mt-1">
                        <span>{{ run.progress.processed }} de {{ run.progress.total }} pagos procesados</span>
                        <span>{{ runPercentage(run) }}%</span>
                      </div>
                    </div>

                    <div *ngIf="run.cancel_reason" class="text-[11px] text-gray-500 mt-1">
                      Motivo: {{ run.cancel_reason }}
                    </div>

                    <div *ngIf="run.overlaps_with?.length"
                         class="flex items-start gap-2 mt-2 text-[11px] bg-amber-50 text-amber-800 rounded px-2 py-1">
                      <i class="fas fa-clone mt-0.5"></i>
                      <span>Corrió en paralelo con el intento {{ run.overlaps_with.join(', ') }} sobre el mismo lote.</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loadingTimeline && timelineMerged.length === 0" class="text-center py-12">
        <i class="fas fa-inbox text-gray-400 text-4xl mb-3"></i>
        <p class="text-gray-600">No hay historial disponible para esta domiciliación</p>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="sticky bottom-0 bg-white flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
      <button 
        (click)="closeTimelineModal()" 
        class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- Payments Modal -->
<div *ngIf="showPaymentsModal" class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
  <div class="relative bg-white rounded-lg shadow-xl max-w-6xl w-full mx-4 max-h-[90vh] flex flex-col">
    <!-- Modal Header -->
    <div class="flex items-start justify-between p-6 border-b border-gray-200">
      <div class="flex-1">
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-xl font-semibold text-gray-900 flex items-center">
              <i class="fas fa-money-bill-wave mr-3 text-emerald-600"></i>
              Cobros - Lote {{selectedDirectDebit?.lote || selectedDirectDebit?.manual_lote}}
            </h3>
            <!-- Banco y tipo: con varios lotes abiertos a la vez, el número solo no
                 alcanza para saber cuál se está mirando. -->
            <div class="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 ml-8 text-xs text-gray-600">
              <span><i class="fas fa-university mr-1 text-gray-400"></i>{{ selectedDirectDebit?.bank?.name || 'Banco no informado' }}</span>
              <span *ngIf="selectedDirectDebit?.type_name"><i class="fas fa-tag mr-1 text-gray-400"></i>{{ selectedDirectDebit?.type_name }}</span>
              <span *ngIf="selectedDirectDebit?.rate"><i class="fas fa-exchange-alt mr-1 text-gray-400"></i>Tasa {{ selectedDirectDebit?.rate | number:'1.2-2' }}</span>
              <span *ngIf="selectedDirectDebit?.status" class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-700 font-medium">
                {{ selectedDirectDebit?.status }}
              </span>
            </div>
          </div>
          <button 
            (click)="refreshPayments()"
            [disabled]="loadingPayments"
            class="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title="Refrescar datos">
            <i class="fas fa-sync-alt mr-2" [class.animate-spin]="loadingPayments"></i>Refrescar
          </button>
        </div>

        <!-- Pestañas -->
        <div class="flex border-b border-gray-300">
          <button *ngIf="conciliationRunning"
            (click)="switchPaymentTab('resumen')"
            [class.border-emerald-600]="activePaymentTab === 'resumen'"
            [class.text-emerald-600]="activePaymentTab === 'resumen'"
            [class.border-transparent]="activePaymentTab !== 'resumen'"
            [class.text-gray-600]="activePaymentTab !== 'resumen'"
            class="px-4 py-2 font-medium border-b-2 transition-colors hover:text-emerald-600">
            <i class="fas fa-chart-pie mr-2"></i>Resumen
          </button>
          <button 
            (click)="switchPaymentTab('detalle')"
            [class.border-emerald-600]="activePaymentTab === 'detalle'"
            [class.text-emerald-600]="activePaymentTab === 'detalle'"
            [class.border-transparent]="activePaymentTab !== 'detalle'"
            [class.text-gray-600]="activePaymentTab !== 'detalle'"
            class="px-4 py-2 font-medium border-b-2 transition-colors hover:text-emerald-600">
            <i class="fas fa-list mr-2"></i>Detalle
          </button>
          <!-- Estadísticas: sólo para lotes ya cerrados. En uno en curso los números
               cambian mientras se los mira y no sirven para sacar conclusiones. -->
          <button *ngIf="loteCerrado()"
            (click)="switchPaymentTab('estadisticas')"
            [class.border-emerald-600]="activePaymentTab === 'estadisticas'"
            [class.text-emerald-600]="activePaymentTab === 'estadisticas'"
            [class.border-transparent]="activePaymentTab !== 'estadisticas'"
            [class.text-gray-600]="activePaymentTab !== 'estadisticas'"
            class="px-4 py-2 font-medium border-b-2 transition-colors hover:text-emerald-600">
            <i class="fas fa-chart-bar mr-2"></i>Estadísticas
          </button>
        </div>
      </div>
      <button (click)="closePaymentsModal()" class="text-gray-400 hover:text-gray-600 ml-4">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>

    <!-- Modal Body with Scroll -->
    <div class="flex-1 overflow-y-auto p-6" (scroll)="onPaymentsScroll($event)">
      
      <!-- Pestaña Resumen -->
      <div *ngIf="activePaymentTab === 'resumen'">
        <div *ngIf="!selectedDirectDebit" class="text-center py-12">
          <p class="text-gray-600">Cargando información del débito directo...</p>
        </div>
        <div *ngIf="selectedDirectDebit && !selectedDirectDebit.trace" class="text-center py-12">
          <i class="fas fa-exclamation-triangle text-yellow-500 text-4xl mb-3"></i>
          <p class="text-gray-600">No hay información de trace disponible para este débito directo.</p>
          <p class="text-sm text-gray-500 mt-2">ID: {{ selectedDirectDebit._id }}</p>
        </div>
        <div *ngIf="selectedDirectDebit && selectedDirectDebit.trace">
          <app-conciliation-progress-monitor
            [traceType]="'DIRECTDEBIT_GENERATE_CONCILIATION_' + selectedDirectDebit.trace"
            [directDebitId]="selectedDirectDebit._id">
          </app-conciliation-progress-monitor>
        </div>
      </div>

      <!-- ═══ Pestaña Estadísticas ═══
           Las tarjetas del Detalle dicen CUÁNTOS registros hay en cada estado; acá se
           responde en plata, que es lo que permite juzgar el resultado del lote. -->
      <div *ngIf="activePaymentTab === 'estadisticas'" class="mt-4">

        <div *ngIf="loadingStats" class="text-center py-12 text-gray-500">
          <i class="fas fa-circle-notch fa-spin text-2xl mb-2"></i>
          <p class="text-sm">Calculando estadísticas…</p>
        </div>

        <div *ngIf="!loadingStats && !stats" class="text-center py-12 text-gray-500">
          <i class="fas fa-chart-bar text-3xl mb-2 text-gray-300"></i>
          <p class="text-sm">No se pudieron cargar las estadísticas de este lote.</p>
        </div>

        <div *ngIf="!loadingStats && stats" class="space-y-5">

          <!-- Resultado en dinero -->
          <div>
            <h4 class="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">Resultado del lote</h4>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
              <div class="border border-gray-200 rounded-lg p-3">
                <div class="text-[10px] font-bold uppercase text-gray-500">Enviado a cobro</div>
                <div class="text-xl font-bold">{{ stats.montos.total.monto | number:'1.2-2' }}</div>
                <div class="text-[11px] text-gray-600" *ngIf="enBs(stats.montos.total.monto) !== null">{{ enBs(stats.montos.total.monto) | number:'1.2-2' }} Bs</div>
                <div class="text-[11px] text-gray-500">{{ stats.montos.total.registros }} registros</div>
              </div>
              <div class="border border-green-200 bg-green-50 rounded-lg p-3">
                <div class="text-[10px] font-bold uppercase text-green-700">Cobrado</div>
                <div class="text-xl font-bold text-green-700">{{ stats.montos.completed.monto | number:'1.2-2' }}</div>
                <div class="text-[11px] text-green-800 font-medium" *ngIf="enBs(stats.montos.completed.monto) !== null">{{ enBs(stats.montos.completed.monto) | number:'1.2-2' }} Bs</div>
                <div class="text-[11px] text-gray-600">
                  {{ stats.montos.completed.registros }} reg · {{ porcentajeMonto(stats.montos.completed.monto) }}% del monto
                </div>
              </div>
              <div class="border border-red-200 bg-red-50 rounded-lg p-3">
                <div class="text-[10px] font-bold uppercase text-red-700">Rechazado</div>
                <div class="text-xl font-bold text-red-700">{{ stats.montos.error.monto | number:'1.2-2' }}</div>
                <div class="text-[11px] text-red-800 font-medium" *ngIf="enBs(stats.montos.error.monto) !== null">{{ enBs(stats.montos.error.monto) | number:'1.2-2' }} Bs</div>
                <div class="text-[11px] text-gray-600">
                  {{ stats.montos.error.registros }} reg · {{ porcentajeMonto(stats.montos.error.monto) }}%
                </div>
              </div>
              <div class="border rounded-lg p-3"
                   [ngClass]="stats.montos.pending.registros > 0 ? 'border-amber-200 bg-amber-50' : 'border-gray-200'">
                <div class="text-[10px] font-bold uppercase text-gray-500">Sin procesar</div>
                <div class="text-xl font-bold" [ngClass]="stats.montos.pending.registros > 0 ? 'text-amber-700' : ''">
                  {{ stats.montos.pending.monto | number:'1.2-2' }}
                </div>
                <div class="text-[11px] text-gray-600" *ngIf="enBs(stats.montos.pending.monto) !== null">{{ enBs(stats.montos.pending.monto) | number:'1.2-2' }} Bs</div>
                <div class="text-[11px] text-gray-600">{{ stats.montos.pending.registros }} registros</div>
              </div>
            </div>
            <p class="text-[11px] text-gray-500 mt-2" *ngIf="stats.lote?.rate">
              Los bolívares se calculan con la tasa del lote ({{ stats.lote.rate | number:'1.2-2' }}), que es la
              que se usó al generarlo.
            </p>
            <p class="text-[11px] text-gray-500 mt-2">
              El porcentaje de registros y el de monto no tienen por qué coincidir: un lote puede
              rechazar muchos registros chicos y aun así cobrar la mayor parte del dinero.
            </p>
          </div>

          <!-- Gráficos -->
          <div class="grid md:grid-cols-2 gap-4">
            <div class="border border-gray-200 rounded-lg p-3">
              <h4 class="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">Monto por resultado</h4>
              <!-- Altura fija obligatoria: con maintainAspectRatio:false y un contenedor
                   sin alto, Chart.js entra en un bucle de redimensionado y el canvas
                   crece indefinidamente. -->
              <div class="dd-chart-box">
                <canvas #statsDonut></canvas>
              </div>
            </div>
            <div class="border border-gray-200 rounded-lg p-3">
              <h4 class="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">Motivos de rechazo</h4>
              <div class="dd-chart-box" *ngIf="stats.rechazos.length > 0">
                <canvas #statsBars></canvas>
              </div>
              <p *ngIf="stats.rechazos.length === 0" class="text-xs text-gray-500 text-center py-6">
                El banco no registró el motivo de los rechazos de este lote.
              </p>
            </div>
          </div>

          <!-- Cruce contra lo aplicado -->
          <div>
            <h4 class="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">Cruce de conciliación</h4>
            <div class="border rounded-lg overflow-hidden"
                 [ngClass]="stats.conciliacion.descuadre != 0 ? 'border-amber-300' : 'border-gray-200'">
              <div class="divide-y divide-gray-200 text-sm">
                <div class="flex justify-between px-3 py-2">
                  <span>Registrado como pago <span class="text-gray-500">({{ stats.conciliacion.pagos_cobrados }} cobros)</span></span>
                  <span class="text-right">
                    <span class="font-semibold">{{ stats.conciliacion.monto_registrado | number:'1.2-2' }}</span>
                    <span class="block text-[11px] text-gray-500" *ngIf="enBs(stats.conciliacion.monto_registrado) !== null">{{ enBs(stats.conciliacion.monto_registrado) | number:'1.2-2' }} Bs</span>
                  </span>
                </div>
                <div class="flex justify-between px-3 py-2">
                  <span class="pl-4 text-gray-600">Aplicado a cuotas</span>
                  <span>{{ stats.conciliacion.aplicado_a_cuotas | number:'1.2-2' }}</span>
                </div>
                <div class="flex justify-between px-3 py-2">
                  <span class="pl-4 text-gray-600">Aplicado a fees</span>
                  <span>{{ stats.conciliacion.aplicado_a_fees | number:'1.2-2' }}</span>
                </div>
                <div class="flex justify-between px-3 py-2 font-semibold">
                  <span>Total aplicado</span>
                  <span class="text-right">
                    <span>{{ stats.conciliacion.total_aplicado | number:'1.2-2' }}</span>
                    <span class="block text-[11px] text-gray-500 font-normal" *ngIf="enBs(stats.conciliacion.total_aplicado) !== null">{{ enBs(stats.conciliacion.total_aplicado) | number:'1.2-2' }} Bs</span>
                  </span>
                </div>
                <div class="flex justify-between px-3 py-2"
                     [ngClass]="stats.conciliacion.descuadre != 0 ? 'bg-amber-50 text-amber-800 font-bold' : 'text-gray-600'">
                  <span>
                    <i class="fas fa-exclamation-triangle mr-1" *ngIf="stats.conciliacion.descuadre != 0"></i>
                    Diferencia
                  </span>
                  <span>{{ stats.conciliacion.descuadre | number:'1.2-2' }}</span>
                </div>
              </div>
            </div>
            <p class="text-[11px] text-gray-500 mt-2">
              Plata que se registró como cobrada pero no llegó a ninguna cuota ni fee.
              Debería ser cero; cualquier otro valor merece revisarse.
            </p>

            <!-- Los pagos concretos detrás de la diferencia. Sin esto el descuadre es un
                 número sin destino: se ve que faltan $2,86 pero no de quién. Cada fila
                 abre el detalle del pago, que es donde se cierra la auditoría. -->
            <div *ngIf="stats.conciliacion.descuadre_pagos?.length > 0" class="mt-3">
              <div class="flex items-baseline justify-between mb-1">
                <h5 class="text-xs font-bold uppercase tracking-wide text-gray-500">
                  Pagos con saldo sin aplicar
                  <span class="font-normal normal-case text-gray-400">({{ stats.conciliacion.descuadre_pagos_total }})</span>
                </h5>
                <span class="text-[11px] text-gray-400">Clic para abrir el pago</span>
              </div>

              <div class="border border-gray-200 rounded-lg overflow-hidden divide-y divide-gray-200">
                <button *ngFor="let p of stats.conciliacion.descuadre_pagos"
                        type="button"
                        (click)="abrirModalPago(p.code, p.person_code, p.person_name)"
                        class="w-full text-left px-3 py-2 hover:bg-amber-50 transition-colors flex items-center justify-between gap-3">
                  <span class="min-w-0">
                    <span class="block text-sm truncate">{{ p.person_name || 'Cliente no informado' }}</span>
                    <span class="block text-[11px] font-mono text-gray-500 truncate">{{ p.reference }}</span>
                  </span>
                  <span class="text-right whitespace-nowrap">
                    <span class="block text-sm font-bold text-amber-700">{{ p.unapplied | number:'1.2-2' }}</span>
                    <span class="block text-[11px] text-gray-500">de {{ p.amount | number:'1.2-2' }} cobrado</span>
                  </span>
                  <i class="fas fa-chevron-right text-gray-300"></i>
                </button>
              </div>

              <p *ngIf="stats.conciliacion.descuadre_pagos_truncado" class="text-[11px] text-gray-500 mt-1">
                Se muestran los 50 de mayor monto, de {{ stats.conciliacion.descuadre_pagos_total }} en total.
              </p>
            </div>
          </div>

          <!-- Motivos en tabla -->
          <div *ngIf="stats.rechazos.length > 0 || stats.rechazos_sin_motivo > 0">
            <h4 class="text-xs font-bold uppercase tracking-wide text-gray-500 mb-2">Detalle de rechazos</h4>
            <div class="border border-gray-200 rounded-lg overflow-hidden">
              <table class="w-full text-sm">
                <tbody class="divide-y divide-gray-200">
                  <tr *ngFor="let r of stats.rechazos">
                    <td class="px-3 py-2 font-mono text-xs text-gray-600 w-20">{{ r.codigo || '—' }}</td>
                    <td class="px-3 py-2">{{ r.descripcion || 'Sin descripción' }}</td>
                    <td class="px-3 py-2 text-right font-semibold w-20">{{ r.registros }}</td>
                  </tr>
                  <tr *ngIf="stats.rechazos_sin_motivo > 0" class="bg-gray-50">
                    <td class="px-3 py-2 text-xs text-gray-500">—</td>
                    <td class="px-3 py-2 text-gray-600 italic">
                      Sin motivo registrado por el banco
                    </td>
                    <td class="px-3 py-2 text-right font-semibold">{{ stats.rechazos_sin_motivo }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>

      <!-- Pestaña Detalle -->
      <div *ngIf="activePaymentTab === 'detalle'">

        <!-- Progress Bar -->
        <div class="mt-4">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm font-medium text-gray-700">Progreso de Procesamiento</span>
            <span class="text-sm font-bold text-blue-600">
              {{paymentsCounts.total > 0 ? ((paymentsCounts.completed + paymentsCounts.error) / paymentsCounts.total * 100).toFixed(1) : 0}}%
            </span>
          </div>
          <div class="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
            <div class="h-full flex">
              <!-- Completed (Green) -->
              <div 
                class="bg-green-500 transition-all duration-500"
                [style.width.%]="paymentsCounts.total > 0 ? (paymentsCounts.completed / paymentsCounts.total * 100) : 0">
              </div>
              <!-- Error (Red) -->
              <div 
                class="bg-red-500 transition-all duration-500"
                [style.width.%]="paymentsCounts.total > 0 ? (paymentsCounts.error / paymentsCounts.total * 100) : 0">
              </div>
            </div>
          </div>
          <div class="flex justify-between mt-1 text-xs text-gray-600">
            <span>{{paymentsCounts.completed + paymentsCounts.error}} procesados de {{paymentsCounts.total}}</span>
            <span>{{paymentsCounts.pending}} pendientes</span>
          </div>
        </div>
        
        <!-- Counters — cada tarjeta filtra la tabla por ese estado. "Total" es el estado
             por defecto (sin filtro) y volver a clickear la tarjeta activa lo quita.
             Los números NO cambian al filtrar: siguen siendo los totales del lote, si no
             dejarían de servir para comparar. -->
        <div class="grid grid-cols-4 gap-4 mt-4">
          <button type="button" (click)="filtrarPorEstado('')"
                  [title]="'Ver todos los registros del lote'"
                  class="dd-stat-card bg-blue-50 text-left"
                  [class.is-active]="paymentsStatusFilter === ''">
            <div class="text-xs text-blue-600 font-medium">Total</div>
            <div class="text-2xl font-bold text-blue-700">{{paymentsCounts.total}}</div>
          </button>
          <button type="button" (click)="filtrarPorEstado('pending')"
                  [title]="'Ver sólo los pendientes'"
                  class="dd-stat-card bg-yellow-50 text-left"
                  [class.is-active]="paymentsStatusFilter === 'pending'">
            <div class="text-xs text-yellow-600 font-medium">Pendientes</div>
            <div class="text-2xl font-bold text-yellow-700">{{paymentsCounts.pending}}</div>
          </button>
          <button type="button" (click)="filtrarPorEstado('error')"
                  [title]="'Ver sólo los no cobrados'"
                  class="dd-stat-card bg-red-50 text-left"
                  [class.is-active]="paymentsStatusFilter === 'error'">
            <div class="text-xs text-red-600 font-medium">No cobrados</div>
            <div class="text-2xl font-bold text-red-700">{{paymentsCounts.error}}</div>
          </button>
          <button type="button" (click)="filtrarPorEstado('completed')"
                  [title]="'Ver sólo los completados'"
                  class="dd-stat-card bg-green-50 text-left"
                  [class.is-active]="paymentsStatusFilter === 'completed'">
            <div class="text-xs text-green-600 font-medium">Completados</div>
            <div class="text-2xl font-bold text-green-700">{{paymentsCounts.completed}}</div>
          </button>
        </div>

        <!-- Qué se está viendo. Sin esto, una tabla filtrada es indistinguible de una
             tabla completa que casualmente empieza con ese estado. -->
        <div *ngIf="paymentsStatusFilter" class="flex items-center gap-2 mt-3 text-sm">
          <span class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gray-100 text-gray-700">
            <i class="fas fa-filter text-xs"></i>
            Mostrando <strong>{{ etiquetaFiltro }}</strong> ({{ totalDelFiltro }})
            <button (click)="filtrarPorEstado('')" title="Quitar el filtro" class="ml-1 text-gray-500 hover:text-gray-800">
              <i class="fas fa-times"></i>
            </button>
          </span>
        </div>

        <!-- Search -->
        <div class="mt-4">
          <div class="flex gap-2">
            <div class="relative flex-1">
              <i class="fas fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input 
                type="text" 
                [(ngModel)]="paymentsSearch"
                (keyup.enter)="searchPayments()"
                placeholder="Buscar por cédula o referencia..."
                class="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500">
            </div>
            <button 
              (click)="searchPayments()"
              class="px-4 py-2 bg-emerald-600 text-white rounded-md hover:bg-emerald-700 transition-colors">
              <i class="fas fa-search mr-1"></i>Buscar
            </button>
            <button 
              *ngIf="paymentsSearch"
              (click)="clearSearch()"
              class="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition-colors">
              <i class="fas fa-times mr-1"></i>Limpiar
            </button>
          </div>
        </div>

        <!-- Loading -->
        <div *ngIf="loadingPayments" class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
      </div>

      <!-- Table (Desktop) -->
      <div *ngIf="!loadingPayments" class="payments-table-desktop overflow-x-auto" data-view="desktop">
        <table class="w-full text-sm">
          <thead class="bg-gray-50 border-b border-gray-200 sticky top-0">
            <tr>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Cédula</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Referencia</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase">Monto</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase">Tasa</th>
              <th class="px-4 py-3 text-right text-xs font-medium text-gray-700 uppercase">Monto Bs</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Estado</th>
              <th class="px-4 py-3 text-left text-xs font-medium text-gray-700 uppercase">Fecha</th>
              <th class="px-4 py-3 text-center text-xs font-medium text-gray-700 uppercase">Pago</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200">
            <ng-container *ngFor="let payment of paymentsData">
            <tr class="hover:bg-gray-50">
              <td class="px-4 py-3 font-mono text-gray-900">{{payment.codeIdentity}}{{payment.identity}}</td>
              <td class="px-4 py-3 text-gray-900 font-mono text-xs">{{payment.reference || '-'}}</td>
              <td class="px-4 py-3 text-right font-medium text-gray-900">{{payment.amount | number:'1.2-2'}}</td>
              <td class="px-4 py-3 text-right text-gray-700">{{payment.rate | number:'1.2-2'}}</td>
              <td class="px-4 py-3 text-right font-medium text-green-700">{{(payment.amount * payment.rate) | number:'1.2-2'}} Bs</td>
              <td class="px-4 py-3">
                <span
                  [class]="payment.status?.toLowerCase().includes('error') || payment.status?.toLowerCase().includes('fail') ? 'bg-red-100 text-red-800' :
                           payment.status?.toLowerCase().includes('complete') || payment.status?.toLowerCase().includes('success') ? 'bg-green-100 text-green-800' :
                           'bg-yellow-100 text-yellow-800'"
                  class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium">
                  {{payment.status || 'PENDING'}}
                </span>
              </td>
              <td class="px-4 py-3 text-gray-600 text-xs">{{formatDate(payment.date)}}</td>
              <td class="px-4 py-3 text-center">
                <!-- Sólo tiene pago lo que ya se procesó: un PENDING nunca llegó a registrarse. -->
                <button *ngIf="payment.status !== 'PENDING'"
                        (click)="verDetallePago(payment)"
                        [disabled]="loadingPaymentDetail"
                        title="Abrir el detalle del pago"
                        class="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50">
                  <i class="fas" [ngClass]="loadingPaymentDetail && expandedPaymentRef === payment.reference ? 'fa-circle-notch fa-spin' : 'fa-search-dollar'"></i>
                </button>
                <span *ngIf="payment.status === 'PENDING'" class="text-gray-300 text-xs">—</span>
              </td>
            </tr>

            </ng-container>
          </tbody>
        </table>

        <!-- Empty State -->
        <div *ngIf="paymentsData.length === 0" class="text-center py-12">
          <i class="fas fa-inbox text-gray-400 text-4xl mb-3"></i>
          <p class="text-gray-600">No se encontraron cobros</p>
        </div>
      </div>

      <!-- Cards (Mobile) -->
      <div *ngIf="!loadingPayments" class="payments-cards-mobile" data-view="mobile">
        <div *ngFor="let payment of paymentsData" class="payment-card">
          <div class="payment-card-row">
            <span class="payment-card-label">Cédula</span>
            <span class="payment-card-value font-mono">{{payment.codeIdentity}}{{payment.identity}}</span>
          </div>
          <div class="payment-card-row">
            <span class="payment-card-label">Referencia</span>
            <span class="payment-card-value font-mono text-xs">{{payment.reference || '-'}}</span>
          </div>
          <div class="payment-card-row">
            <span class="payment-card-label">Monto</span>
            <span class="payment-card-value">{{payment.amount | number:'1.2-2'}}</span>
          </div>
          <div class="payment-card-row">
            <span class="payment-card-label">Tasa</span>
            <span class="payment-card-value">{{payment.rate | number:'1.2-2'}}</span>
          </div>
          <div class="payment-card-row">
            <span class="payment-card-label">Monto Bs</span>
            <span class="payment-card-value text-green-700">{{(payment.amount * payment.rate) | number:'1.2-2'}} Bs</span>
          </div>
          <div class="payment-card-row">
            <span class="payment-card-label">Estado</span>
            <span 
              [class]="payment.status?.toLowerCase().includes('error') || payment.status?.toLowerCase().includes('fail') ? 'bg-red-100 text-red-800' : 
                       payment.status?.toLowerCase().includes('complete') || payment.status?.toLowerCase().includes('success') ? 'bg-green-100 text-green-800' : 
                       'bg-yellow-100 text-yellow-800'"
              class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium">
              {{payment.status || 'PENDING'}}
            </span>
          </div>
          <div class="payment-card-row">
            <span class="payment-card-label">Fecha</span>
            <span class="payment-card-value text-xs">{{formatDate(payment.date)}}</span>
          </div>
        </div>

        <!-- Empty State -->
        <div *ngIf="paymentsData.length === 0" class="text-center py-12">
          <i class="fas fa-inbox text-gray-400 text-4xl mb-3"></i>
          <p class="text-gray-600">No se encontraron cobros</p>
        </div>
      </div>

      <!-- Loading More -->
      <div *ngIf="loadingMorePayments" class="flex justify-center items-center py-4">
        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
        <span class="ml-2 text-gray-600">Cargando más...</span>
      </div>

      <!-- No More Data -->
      <div *ngIf="!loadingMorePayments && !paymentsHasMore && paymentsData.length > 0" class="text-center py-4 text-gray-500 text-sm">
        No hay más registros
      </div>

      </div><!-- Cierre pestaña Detalle -->
    </div>

    <!-- Modal Footer -->
    <div class="flex items-center justify-end space-x-3 p-6 border-t border-gray-200">
      <button 
        (click)="closePaymentsModal()" 
        class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors">
        Cerrar
      </button>
    </div>
  </div>
</div>

<!-- ============================================ -->
<!-- MODAL DE REPORTE DE SEGUROS -->
<!-- ============================================ -->
<div *ngIf="showInsuranceReportModal" 
     class="fixed inset-0 z-50 overflow-y-auto" 
     aria-labelledby="modal-title" 
     role="dialog" 
     aria-modal="true">
  <!-- Backdrop -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
       (click)="closeInsuranceReportModal()"></div>

  <!-- Modal Content -->
  <div class="flex items-center justify-center min-h-screen p-4">
    <div class="relative bg-white rounded-lg shadow-xl max-w-7xl w-full max-h-[90vh] overflow-hidden">
      
      <!-- Header -->
      <div class="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4">
        <div class="flex items-center justify-between">
          <h3 class="text-xl font-bold text-white flex items-center">
            <i class="fas fa-file-medical-alt mr-3"></i>
            Estatus de Reporte de Seguros
          </h3>
          <button 
            (click)="closeInsuranceReportModal()" 
            class="text-white hover:text-gray-200 transition-colors">
            <i class="fas fa-times text-2xl"></i>
          </button>
        </div>
        <p class="text-blue-100 text-sm mt-1" *ngIf="selectedDirectDebit">
          Lote: {{selectedDirectDebit.lote || selectedDirectDebit.manual_lote}} | 
          Banco: {{selectedDirectDebit.bank?.name}}
        </p>
      </div>

      <!-- Body -->
      <div class="p-6 overflow-y-auto" style="max-height: calc(90vh - 200px);">
        
        <!-- Loading -->
        <div *ngIf="loadingInsuranceReport" class="text-center py-12">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p class="text-gray-600">Cargando reporte de seguros...</p>
        </div>

        <!-- Content -->
        <div *ngIf="!loadingInsuranceReport">
          
          <!-- Estadísticas -->
          <div class="grid grid-cols-4 gap-4 mb-6" *ngIf="insuranceReportStats">
            <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
              <div class="text-sm text-gray-600 mb-1">Total</div>
              <div class="text-3xl font-bold text-gray-800">{{insuranceReportStats.total}}</div>
            </div>
            <div class="bg-green-50 rounded-lg p-4 border border-green-200">
              <div class="text-sm text-green-700 mb-1">Reportados</div>
              <div class="text-3xl font-bold text-green-800">{{insuranceReportStats.reported}}</div>
              <div class="text-xs text-green-600 mt-1">{{insuranceReportStats.reported_percentage}}%</div>
            </div>
            <div class="bg-yellow-50 rounded-lg p-4 border border-yellow-200">
              <div class="text-sm text-yellow-700 mb-1">Pendientes</div>
              <div class="text-3xl font-bold text-yellow-800">{{insuranceReportStats.pending}}</div>
              <div class="text-xs text-yellow-600 mt-1">{{insuranceReportStats.pending_percentage}}%</div>
            </div>
            <div class="bg-red-50 rounded-lg p-4 border border-red-200">
              <div class="text-sm text-red-700 mb-1">Fallidos</div>
              <div class="text-3xl font-bold text-red-800">{{insuranceReportStats.failed}}</div>
              <div class="text-xs text-red-600 mt-1">{{insuranceReportStats.failed_percentage}}%</div>
            </div>
          </div>

          <!-- Botón de exportar -->
          <div class="mb-4 text-right">
            <button 
              (click)="exportInsuranceReport()"
              class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm">
              <i class="fas fa-file-excel mr-2"></i>Exportar a CSV
            </button>
          </div>

          <!-- Tabla de pagos -->
          <div class="overflow-x-auto">
            <table class="w-full text-sm">
              <thead class="bg-gray-100 border-b-2 border-gray-300">
                <tr>
                  <th class="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Referencia</th>
                  <th class="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Cliente</th>
                  <th class="px-3 py-3 text-right text-xs font-semibold text-gray-700 uppercase">Monto</th>
                  <th class="px-3 py-3 text-center text-xs font-semibold text-gray-700 uppercase">Cuota</th>
                  <th class="px-3 py-3 text-center text-xs font-semibold text-gray-700 uppercase">Estado Reporte</th>
                  <th class="px-3 py-3 text-center text-xs font-semibold text-gray-700 uppercase">Intentos</th>
                  <th class="px-3 py-3 text-left text-xs font-semibold text-gray-700 uppercase">Último Error</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr *ngFor="let item of insuranceReportData" class="hover:bg-gray-50 transition-colors">
                  <!-- Referencia -->
                  <td class="px-3 py-3">
                    <div class="font-mono text-xs text-gray-900">{{item.payment_code}}</div>
                    <div class="text-xs text-gray-500">{{formatDateTime(item.payment_date)}}</div>
                  </td>

                  <!-- Cliente -->
                  <td class="px-3 py-3">
                    <div class="font-medium text-gray-900">{{item.customer_name}}</div>
                    <div class="text-xs text-gray-500">{{item.customer_document}}</div>
                  </td>

                  <!-- Monto -->
                  <td class="px-3 py-3 text-right">
                    <span class="font-semibold text-gray-900">${{item.payment_amount | number:'1.2-2'}}</span>
                  </td>

                  <!-- Cuota -->
                  <td class="px-3 py-3 text-center">
                    <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                      Cuota {{item.installment_number}}
                    </span>
                  </td>

                  <!-- Estado del Reporte -->
                  <td class="px-3 py-3 text-center">
                    <span [class]="getReportStatusClass(item)" 
                          class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium">
                      {{getReportStatusText(item)}}
                    </span>
                    <div *ngIf="item.reported_at" class="text-xs text-gray-500 mt-1">
                      {{formatDateTime(item.reported_at)}}
                    </div>
                  </td>

                  <!-- Intentos -->
                  <td class="px-3 py-3">
                    <div class="text-center">
                      <div class="font-semibold text-gray-900 mb-1">
                        {{item.current_attempt}} / {{item.max_attempts}}
                      </div>
                      <!-- Barra de progreso -->
                      <div class="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          [class]="item.reportado ? 'bg-green-600' : 
                                   (item.current_attempt >= item.max_attempts ? 'bg-red-600' : 'bg-yellow-500')"
                          class="h-2 rounded-full transition-all"
                          [style.width.%]="(item.current_attempt / item.max_attempts) * 100">
                        </div>
                      </div>
                      <!-- Advertencia de límite vencido -->
                      <div *ngIf="item.current_attempt >= item.max_attempts && !item.reportado" 
                           class="text-xs text-red-600 font-semibold mt-1">
                        <i class="fas fa-exclamation-triangle"></i> Límite vencido
                      </div>
                    </div>
                  </td>

                  <!-- Último Error -->
                  <td class="px-3 py-3">
                    <div *ngIf="item.last_error" class="max-w-xs">
                      <div class="text-xs text-red-600 font-medium flex items-start">
                        <i class="fas fa-exclamation-circle mr-1 mt-0.5"></i>
                        <span>{{item.last_error}}</span>
                      </div>
                      <div class="text-xs text-gray-500 mt-1">
                        {{formatDateTime(item.last_error_date)}}
                      </div>
                    </div>
                    <span *ngIf="!item.last_error" class="text-xs text-gray-400">Sin errores</span>
                  </td>
                </tr>

                <!-- Sin datos -->
                <tr *ngIf="insuranceReportData.length === 0">
                  <td colspan="7" class="px-3 py-12 text-center">
                    <i class="fas fa-inbox text-gray-400 text-4xl mb-3"></i>
                    <p class="text-gray-600">No hay pagos de seguros para mostrar</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <!-- Footer -->
      <div class="flex items-center justify-end space-x-3 p-6 border-t border-gray-200 bg-gray-50">
        <button 
          (click)="closeInsuranceReportModal()" 
          class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors">
          Cerrar
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Detalle de Pago — se reusa el componente genérico (app-person-payments), el mismo que
     usa la consola de pagos. Antes había un detalle propio acá, incompleto y con otra
     estructura visual: se quitó para no duplicar ni divergir. -->
<div *ngIf="showPaymentDetailModal"
     class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60] flex items-start justify-center p-4">
  <div class="relative bg-white rounded-lg shadow-xl max-w-5xl w-full mt-8 max-h-[90vh] overflow-y-auto">
    <div class="sticky top-0 bg-white flex items-center justify-between p-4 border-b border-gray-200 z-10">
      <div>
        <h3 class="text-lg font-semibold text-gray-900">
          <i class="fas fa-receipt mr-2 text-indigo-600"></i>Detalle de Pago
        </h3>
        <p class="text-xs text-gray-500 mt-0.5" *ngIf="paymentDetailPerson">{{ paymentDetailPerson }}</p>
      </div>
      <button (click)="cerrarDetallePago()" class="text-gray-400 hover:text-gray-600">
        <i class="fas fa-times text-xl"></i>
      </button>
    </div>
    <div class="p-4">
      <app-person-payments
        [code_person]="paymentDetailPersonCode"
        [code_payment]="paymentDetailCode">
      </app-person-payments>
    </div>
  </div>
</div>
